import React, { useState, useEffect } from "react";
import '../styles/ClientDebtSummary.css'; // Optional, for styling
import Swal from 'sweetalert2';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { formatCurrencyUSD } from "../utils/format";

const ClientDebtSummary = () => {
  // State to store the data and sort direction
  const [data, setData] = useState([]);
  // const [depositData, setDepositData] = useState({});
  // const [settlementData, setSettlementData] = useState({});
  // const [feesData, setFeesData] = useState({});
  const [accountBalData, setAccountBalData] = useState(null);
  const [transactionDataWDebtID, setTransactionDataWDebtID] = useState({});
  const [allTransactionData, setAllTransactionData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState(null);
  const [clientid, setClientid] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalEditableTransactionOpen, setIsModalEditableTransactionOpen] = useState(false);
  const [isModalTransactionOpen, setIsModalTransactionOpen] = useState(false);
  const [isModalRecalculationFeeOpen, setIsModalRecalculationFeeOpen] = useState(false);
  const [isModalRecalculationFeesOpen, setIsModalRecalculationFeesOpen] = useState(false);
  const [isModalRecalculationSettlementOpen, setIsModalRecalculationSettlementOpen] = useState(false);

  const [selectedDebt, setSelectedDebt] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [calculatorType, setCalculatorType] = useState("1");
  const [feeCollectionType, setFeeCollectionType] = useState("1");


  const [selectedTableNameFilter, setSelectedTableNameFilter] = useState([]);
  const [uniqueTableNames, setUniqueTableNames] = useState([]);

  const [selectedStatusFilter, setSelectedStatusFilter] = useState([]);
  const [uniqueStatuses, setUniqueStatuses] = useState([]);
  const [filteredUniqueStatuses, setFilteredUniqueStatuses] = useState([]);

  const [selectedDebtIdFilter, setSelectedDebtIdFilter] = useState([]);
  const [uniqueDebtIds, setUniqueDebtIds] = useState([]);

  const [sortedData, setSortedData] = useState([]);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const statusOptions = [
  "Open",
  "Pending",
  "Pending For Batch",
  "Cancel",
  "Cleared",
  "Pending For Journal",
  "Void",
  "Returned / NSF",
  "Correction",
  "Rejected",
  "Resubmitted",
  "Reversed",
  "Low Balance",
  "Error Processing",
  "Shipped",
  "Pending Approval",
  "Stop Payment",
  "Authorized",
  "On Hold",
  "Pending Update",
  "Delivered",
  "Unauth Return"
];

const originalToTransactionStatus = {
  "Open": "SCHEDULED",
  "Pending": "COMPLETED",
  "Pending For Batch": "COMPLETED",
  "Cancel": "CANCELLED",
  "Cleared": "COMPLETED",
  "Pending For Journal": "COMPLETED",
  "Void": "CANCELLED",
  "Returned / NSF": "COMPLETED",
  "Correction": "COMPLETED",
  "Rejected": "CANCELLED",
  "Resubmitted": "COMPLETED",
  "Reversed": "COMPLETED",
  "Low Balance": "PENDING",
  "Error Processing": "CANCELLED",
  "Shipped": "PENDING",
  "Pending Approval": "PENDING",
  "Stop Payment": "COMPLETED",
  "Authorized": "COMPLETED",
  "On Hold": "PENDING",
  "Pending Update": "PENDING",
  "Delivered": "COMPLETED",
  "Unauth Return": "COMPLETED"
};

const noImpactStatuses = [
  "Void",
  "Returned / NSF",
  "Cancel",
  "Stop Payment",
  //"Unauth Return", 
  // removed Unauth Return to special cases transaction - requested by Mylene 21JAN2026
  // Added new statuses - 26JAN2026
  'Reversed',
  'Error Processing',
  'Rejected'
];

const handleStatusChange = (row, newOriginalStatus) => {
  const newTransactionStatus = originalToTransactionStatus[newOriginalStatus] || "N/A";
  const noImpact = noImpactStatuses.includes(newOriginalStatus);

  // First update the row's statuses
  let updated = resultTransEditable.map(r =>
    r.TransID === row.TransID
      ? {
          ...r,
          OriginalTransactionStatus: newOriginalStatus,
          TransactionStatus: newTransactionStatus,
          NoImpactBalance: noImpact
        }
      : r
  );

  // Then recalc balance for the entire list
  updated = recalcForecastBalance(updated);

  console.log("Updated Balance1: ", updated);

  const updatedData = getDebtDetailsAllTransactionsEditableUpdated(updated);

  console.log("Updated Balance2: ", updatedData);
  setResultTransEditable(updatedData);
  //setResultTransEditable(updated);   // ONE state update only → NO infinite loop
};


  // Handler to clear all filters
  const clearFilters = () => {
    setSelectedTableNameFilter([]);
    setSelectedStatusFilter([]);
    setSelectedDebtIdFilter([]);
    setDateFrom('');
    setDateTo('');
  };

  
const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          {typeof children === 'string' ? (
            <Typography>{children}</Typography>
          ) : (
            children
          )}
        </Box>
      )}
    </div>
  );
};
 const DebtIDFilterDropdown = ({ selectedFilter, onChange, options }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleCheckboxChange = (option, isChecked) => {
      if (isChecked) {
        onChange([...selectedFilter, option]);
      } else {
        onChange(selectedFilter.filter(item => item !== option));
      }
    };

    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px', position: 'relative' }}>
        <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
          Filter by Debt ID
        </label>
        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            height: '40px',
            padding: '10px',
            border: '1px solid #D1D5DB',
            borderRadius: '7px',
            backgroundColor: 'white',
            cursor: 'pointer',
            width: '200px',
            textAlign: 'left',
            fontSize: '1em',
            fontWeight: '500',
            color: '#374151'
          }}
        >
          Debt ID {selectedFilter.length > 0 ? `(${selectedFilter.length})` : ''}
        </button>
        {isOpen && (
          <div
            style={{
              border: '1px solid #D1D5DB',
              borderRadius: '7px',
              padding: '10px',
              backgroundColor: 'white',
              width: '150px',
              maxHeight: '150px',
              overflowY: 'auto',
              position: 'absolute',
              top: '100%',
              left: '0',
              zIndex: 1000
            }}
          >
            {options.map(option => (
              <div key={option} style={{ marginBottom: '5px' }}>
                <label style={{ display: 'flex', alignItems: 'center', fontSize: '1em', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={selectedFilter.includes(option)}
                    onChange={(e) => handleCheckboxChange(option, e.target.checked)}
                    style={{ marginRight: '8px' }}
                  />
                  {option}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

 const TableNameFilterDropdown = ({ selectedFilter, onChange, options }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleCheckboxChange = (option, isChecked) => {
      if (isChecked) {
        onChange([...selectedFilter, option]);
      } else {
        onChange(selectedFilter.filter(item => item !== option));
      }
    };

    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px', position: 'relative' }}>
        <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
          Filter by Transaction
        </label>
        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            height: '40px',
            padding: '10px',
            border: '1px solid #D1D5DB',
            borderRadius: '7px',
            backgroundColor: 'white',
            cursor: 'pointer',
            width: '250px',
            textAlign: 'left',
            fontSize: '1em',
            fontWeight: '500',
            color: '#374151'
          }}
        >
          Transaction {selectedFilter.length > 0 ? `(${selectedFilter.length})` : ''}
        </button>
        {isOpen && (
          <div
            style={{
              border: '1px solid #D1D5DB',
              borderRadius: '7px',
              padding: '10px',
              backgroundColor: 'white',
              width: '250px',
              maxHeight: '150px',
              overflowY: 'auto',
              position: 'absolute',
              top: '100%',
              left: '0',
              zIndex: 1000
            }}
          >
            {options.map(option => (
              <div key={option} style={{ marginBottom: '5px' }}>
                <label style={{ display: 'flex', alignItems: 'center', fontSize: '1em', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={selectedFilter.includes(option)}
                    onChange={(e) => handleCheckboxChange(option, e.target.checked)}
                    style={{ marginRight: '8px' }}
                  />
                  {option}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };


  const StatusFilterDropdown = ({ selectedFilter, onChange, options }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleCheckboxChange = (option, isChecked) => {
      if (isChecked) {
        onChange([...selectedFilter, option]);
      } else {
        onChange(selectedFilter.filter(item => item !== option));
      }
    };

    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px', position: 'relative' }}>
        <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
          Filter by Overall Status
        </label>
        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            height: '40px',
            padding: '10px',
            border: '1px solid #D1D5DB',
            borderRadius: '7px',
            backgroundColor: 'white',
            cursor: 'pointer',
            width: '200px',
            textAlign: 'left',
            fontSize: '1em',
            fontWeight: '500',
            color: '#374151'
          }}
        >
          Statuses {selectedFilter.length > 0 ? `(${selectedFilter.length})` : ''}
        </button>
        {isOpen && (
          <div
            style={{
              border: '1px solid #D1D5DB',
              borderRadius: '7px',
              padding: '10px',
              backgroundColor: 'white',
              width: '150px',
              maxHeight: '150px',
              overflowY: 'auto',
              position: 'absolute',
              top: '100%',
              left: '0',
              zIndex: 1000
            }}
          >
            {options.map(option => (
              <div key={option} style={{ marginBottom: '5px' }}>
                <label style={{ display: 'flex', alignItems: 'center', fontSize: '1em', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={selectedFilter.includes(option)}
                    onChange={(e) => handleCheckboxChange(option, e.target.checked)}
                    style={{ marginRight: '8px' }}
                  />
                  {option}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const filterByDateRange = (data, from, to) => {
    if (!from && !to) return data;
    return data.filter(item => {
      if (item.ClearedDate === 'N/A') return false;
      const date = new Date(item.ClearedDate);
      const fromDate = from ? new Date(from) : null;
      const toDate = to ? new Date(to) : null;
      if (fromDate && date < fromDate) return false;
      if (toDate && date > toDate) return false;
      return true;
    });
  };

  const [value, setValue] = React.useState(0);
  const [valueTrans, setValueTrans] = React.useState(0);
  const [valueTransEditable, setValueTransEditable] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }

  const handleChangeTrans = (event, newValue) => {
    setValueTrans(newValue);
  }

  const handleChangeTransEditable = (event, newValue) => {
    setValueTransEditable(newValue);
  }

  const getMonthlyGroupedData = (transLog) => {
    const depositKeywords = ["debit", "advance", "deposit"];
    const settlementKeywords = ["payment"];
    const feesKeywords = ["fee"];

    const depositData = [];
    const settlementData = [];
    const feesData = [];

    // --- Step 1: Categorize transactions
    for (const trans of transLog) {
      const title = trans.TransactionTitle?.toLowerCase() ?? "";

      if (depositKeywords.some(k => title.includes(k))) {
        depositData.push(trans);
      } else if (settlementKeywords.some(k => title.includes(k))) {
        settlementData.push(trans);
      } else if (feesKeywords.some(k => title.includes(k))) {
        feesData.push(trans);
      }
    }

    // --- Step 2: Collect all months
    const allMonthsSet = new Set();
    [...depositData, ...settlementData, ...feesData].forEach(t =>
      allMonthsSet.add(t.YearMonth)
    );
    const allMonths = Array.from(allMonthsSet);

    // --- Helpers
    const monthIndexMap = {
      JAN:0,FEB:1,MAR:2,APR:3,MAY:4,JUN:5,
      JUL:6,AUG:7,SEP:8,OCT:9,NOV:10,DEC:11
    };

    let counterID =
      Math.max(
        0,
        ...depositData.map(d => d.CounterID || 0),
        ...settlementData.map(d => d.CounterID || 0),
        ...feesData.map(d => d.CounterID || 0)
      ) + 1;

    const createDummyData = (baseData, title, type) =>
      allMonths
        .filter(month => !baseData.some(d => d.YearMonth === month))
        .map(month => {
          const [mon, year] = month.split(" ");
          const lastDate = new Date(
            Number(year),
            (monthIndexMap[mon.toUpperCase()] ?? 0) + 1,
            0
          );

          return {
            Amount: 0,
            ProcessDate: lastDate.toISOString().split("T")[0],
            ClearedDate: lastDate.toISOString().split("T")[0],
            CounterID: counterID++,
            DebtID: 0,
            ForecastEndingBalance: 0,
            OriginalTransactionStatus: "Open",
            TransID: Math.floor(Math.random() * 1e10),
            TransactionStatus: "SCHEDULED",
            TransactionTitle: title,
            Type: type,
            YearMonth: month,
            isDummy: true
          };
        });

    // --- Step 3: Add dummy data
    const fullDepositData = [
      ...depositData,
      ...createDummyData(depositData, "ACH Client Debit", "Debit")
    ];

    const fullSettlementData = [
      ...settlementData,
      ...createDummyData(settlementData, "Settlement Payment", "Credit")
    ];

    const fullFeesData = [
      ...feesData,
      ...createDummyData(feesData, "Fee", "Credit")
    ];

    // --- Step 4: Group helper
    const groupByMonth = (data) =>
      data.reduce((acc, item) => {
        acc[item.YearMonth] = (acc[item.YearMonth] || 0) + Number(item.Amount);
        return acc;
      }, {});

    // --- Step 5: Sort helper
    const sortMonthGroups = (groupObj) => {
      return Object.entries(groupObj)
        .sort((a, b) => {
          const [mA, yA] = a[0].split(" ");
          const [mB, yB] = b[0].split(" ");
          if (yA !== yB) return Number(yA) - Number(yB);
          return monthIndexMap[mA] - monthIndexMap[mB];
        })
        .map(e => e[1]);
    };

    return {
      monthlyDeposit: sortMonthGroups(groupByMonth(fullDepositData)),
      monthlySettlement: sortMonthGroups(groupByMonth(fullSettlementData)),
      monthlyFees: sortMonthGroups(groupByMonth(fullFeesData)),
      depositData: fullDepositData,
      settlementData: fullSettlementData,
      feesData: fullFeesData
    };
  };


  // VERSION 1 SINGLE EPF - COMPUTES DATA FROM GROUPED TO MONTHLY
  const calculateFeeAllocationv1 = () => {
    if (!selectedDebt) return [];
    const debtID = selectedDebt.debtId;

    console.log("Single EPF Data Updated:", resultTransEditable);

    const fullTransLog = resultTransEditable.filter(item =>
      !(item.TransactionTitle === "Earned Performance Fee" && item.DebtID === debtID)
    );
     console.log("Single EPF Data Updated Excluded EPF:", fullTransLog);

    const {
      monthlyDeposit,
      monthlySettlement,
      monthlyFees
    } = getMonthlyGroupedData(fullTransLog);
   
    const today = new Date();
    const maxMonths = 60;

    let balance = accountBalData;
    const feeDue = parseFloat(selectedDebt.pendingFee || 0);
    let feeRemaining = feeDue;

    const feeLog = [];
    let monthIndex = 0;

    while (feeRemaining > 0 && monthIndex < maxMonths) {
        const deposit = monthlyDeposit[monthIndex] ?? monthlyDeposit[0] ?? 0;
        const settlement = monthlySettlement[monthIndex] ?? 0;
        const fees = monthlyFees[monthIndex] ?? 0;

        // Apply formula: CURRENT BALANCE + (DEPOSIT - FEES) - SETTLEMENT
        balance = balance + (deposit - fees) - settlement;

        // --- Calculate minimum required balance for immediate next month only ---
        let nextMonthRequirement = 0;
        if (monthIndex + 1 < monthlySettlement.length) {
            const nextDeposit = monthlyDeposit[monthIndex + 1] ?? monthlyDeposit[0] ?? 0;
            const nextSettlement = monthlySettlement[monthIndex + 1] ?? 0;
            const nextFees = monthlyFees[monthIndex + 1] ?? 0;
            
            // Only reserve if next month has a shortfall
            const nextMonthShortfall = (nextSettlement + nextFees) - nextDeposit;
            if (nextMonthShortfall > 0) {
                nextMonthRequirement = nextMonthShortfall;
            }
        }

        // --- Aggressive collection: use all available balance above minimum requirement ---
        let availableForFee = balance - nextMonthRequirement;
        
        // Ensure we don't go negative
        if (availableForFee < 0) availableForFee = 0;

        const feePayment = Math.min(availableForFee, feeRemaining);
        feeRemaining = parseFloat((feeRemaining - feePayment).toFixed(2));
        balance = parseFloat((balance - feePayment).toFixed(2));

        const scheduledDate = new Date(today);
        scheduledDate.setMonth(today.getMonth() + monthIndex);

        feeLog.push({
            month: monthIndex + 1,
            feeCollected: parseFloat(feePayment.toFixed(2)),
            remainingFee: feeRemaining,
            remainingBalance: balance,
            scheduleDate: scheduledDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            }),
            balanceWentNegative: balance < 0
        });

        monthIndex++;
    }

    return feeLog;
};

// VERSION 2 SINGLE EPF - COMPUTES DATA FROM DATA TRANSACTION BASED AND FORECASTING
const calculateFeeAllocation = () => {
    if (!selectedDebt) return [];

    const debtID = selectedDebt.debtId;
    let counterID = 1;

    const round2 = (v) => Number((Number(v) || 0).toFixed(2));

    const formatISODate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };

    const normalizeBalances = (log) =>
        log.map(t => ({
            ...t,
            ForecastEndingBalance: round2(t.ForecastEndingBalance)
        }));

    const sumFutureCredits = (log, startIndex) => {
        let sum = 0;
        for (let i = startIndex; i < log.length; i++) {
            const t = log[i];
            if (
                t.Type === "Credit" &&
                t.TransactionTitle !== "Earned Performance Fee" &&
                t.DebtID === debtID
            ) {
                sum += Number(t.Amount) || 0;
            }
        }
        return round2(sum);
    };

    const simulateEPF = (log, insertIndex, amount, formattedDate) => {
        const epf = {
            Amount: amount,
            ProcessDate: formattedDate,
            ClearedDate: formattedDate,
            CounterID: counterID,
            DebtID: debtID,
            ForecastEndingBalance: 0,
            OriginalTransactionStatus: "Open",
            TransID: 0,
            TransactionStatus: "SCHEDULED",
            TransactionTitle: "Earned Performance Fee",
            Type: "Credit",
            isDummy: true
        };

        const testLog = [...log];
        testLog.splice(insertIndex, 0, epf);

        const recalculated = normalizeBalances(recalcForecastBalance(testLog));
        const futureTxns = recalculated.slice(insertIndex);

        const minBalance = Math.min(...futureTxns.map(t => t.ForecastEndingBalance));
        const futureCredits = sumFutureCredits(testLog, insertIndex + 1);
        const endingBalanceAfterEPF = futureTxns[0]?.ForecastEndingBalance || 0;

        return {
            ok: minBalance >= 0 && futureCredits + endingBalanceAfterEPF >= 0,
            endingBalance: endingBalanceAfterEPF,
            recalculated
        };
    };

    const computeSuggestedEPF = (log, insertIndex, cap, formattedDate) => {
        let low = 0, high = cap, best = 0;

        while (low <= high) {
            const mid = round2((low + high) / 2);
            if (simulateEPF(log, insertIndex, mid, formattedDate).ok) {
                best = mid;
                low = round2(mid + 0.01);
            } else {
                high = round2(mid - 0.01);
            }
        }
        return round2(best);
    };

    const nowDate = new Date();
    const startOfThisMonth = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);

    let fullTransLog = resultTransEditable
    // 🔹 Remove existing EPFs
    .filter(
        t => !(t.TransactionTitle === "Earned Performance Fee" && t.DebtID === debtID)
    )
    // 🔹 Keep only this month and forward
    .filter(t => {
        const [mn, y] = t.YearMonth.split(" ");
        const monthDate = new Date(y, new Date(`${mn} 1`).getMonth(), 1);
        return monthDate >= startOfThisMonth;
    });

    fullTransLog = normalizeBalances(recalcForecastBalance(fullTransLog));

    let feeRemaining = round2(selectedDebt.pendingFee || 0);
    if (feeRemaining <= 0) return [];

    const feeLog = [];

    const now = new Date();
    const months = [...new Set(fullTransLog.map(t => t.YearMonth))]
        .filter(m => {
            const [mn, y] = m.split(" ");
            return new Date(y, new Date(`${mn} 1`).getMonth(), 1) >=
                new Date(now.getFullYear(), now.getMonth(), 1);
        })
        .sort((a, b) => new Date(a) - new Date(b));

    let monthIndex = 0;

    for (const yearMonth of months) {
        // 🔴 Stop once EPF is fully completed
        if (feeRemaining <= 0) break;

        const monthTxns = fullTransLog.filter(t => t.YearMonth === yearMonth);
        if (!monthTxns.length) continue;

        const lastTxn = monthTxns[monthTxns.length - 1];
        const available = round2(lastTxn.ForecastEndingBalance);

        const [mn, y] = yearMonth.split(" ");
        const lastDay = new Date(y, new Date(`${mn} 1`).getMonth() + 1, 0);
        const formattedDate = formatISODate(lastDay);

        const insertIndex = fullTransLog.lastIndexOf(lastTxn) + 1;

        let collectedThisMonth = 0;
        let remainingBalanceForLog = available;

        if (available > 0) {
            const cap = Math.min(available, feeRemaining);

            let suggestedEPF = computeSuggestedEPF(
                fullTransLog,
                insertIndex,
                cap,
                formattedDate
            );

            if (suggestedEPF > 0) {
                let sim = simulateEPF(
                    fullTransLog,
                    insertIndex,
                    suggestedEPF,
                    formattedDate
                );
                fullTransLog = sim.recalculated;

                remainingBalanceForLog = sim.endingBalance;

                let remainingAfterSuggested =
                    round2(feeRemaining - suggestedEPF);

                // 🔹 Aggressive top-up
                if (remainingAfterSuggested > 0 && sim.endingBalance > 0) {
                    const topUpCap = Math.min(
                        sim.endingBalance,
                        remainingAfterSuggested
                    );

                    let low = 0, high = topUpCap, bestTopUp = 0;

                    while (low <= high) {
                        const mid = round2((low + high) / 2);
                        if (
                            simulateEPF(
                                fullTransLog,
                                insertIndex,
                                mid,
                                formattedDate
                            ).ok
                        ) {
                            bestTopUp = mid;
                            low = round2(mid + 0.01);
                        } else {
                            high = round2(mid - 0.01);
                        }
                    }

                    if (bestTopUp > 0) {
                        let simTopUp = simulateEPF(
                            fullTransLog,
                            insertIndex,
                            bestTopUp,
                            formattedDate
                        );
                        fullTransLog = simTopUp.recalculated;

                        suggestedEPF = round2(suggestedEPF + bestTopUp);
                        remainingBalanceForLog = simTopUp.endingBalance;
                    }
                }

                collectedThisMonth = suggestedEPF;
                feeRemaining = round2(feeRemaining - suggestedEPF);
            }
        }

        // ✅ Always log month if EPF was still remaining at start
        feeLog.push({
            month: ++monthIndex,
            feeCollected: collectedThisMonth,
            remainingFee: feeRemaining,
            remainingBalance: remainingBalanceForLog,
            scheduleDate: lastDay.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric"
            })
        });
    }

    return feeLog;
};




 // VERSION 1 MULTIPLE EPF - COMPUTES DATA FROM GROUPED TO MONTHLY
 const recalculateFeesv1 = (feeCollectionType) => {
  const today = new Date();
  const maxMonths = 60;

  const fullTransLog = resultTransEditable.filter(
    t => t.TransactionTitle !== "Earned Performance Fee"
  );

  const {
    monthlyDeposit,
    monthlySettlement,
    monthlyFees
  } = getMonthlyGroupedData(fullTransLog);

  let globalBalance = accountBalData;

  // Clone debts
  const debts = data
    .filter(d => parseFloat(d.pendingFee) > 0)
    .map(d => ({
      ...d,
      pendingFee: parseFloat(d.pendingFee || 0),
      feeLog: []
    }));

  const sortDebts = () =>
    [...debts].sort((a, b) => {
      switch (feeCollectionType) {
        case '1': return b.pendingFee - a.pendingFee;
        case '2': return a.pendingFee - b.pendingFee;
        case '3': return String(a.debtId).localeCompare(String(b.debtId));
        case '4': return (a.priority || 0) - (b.priority || 0);
        default: return 0;
      }
    });

  for (let monthIndex = 0; monthIndex < maxMonths; monthIndex++) {
    if (debts.every(d => d.pendingFee <= 0)) break;

    const deposit = monthlyDeposit[monthIndex] ?? monthlyDeposit[0] ?? 0;
    const settlement = monthlySettlement[monthIndex] ?? 0;
    const fees = monthlyFees[monthIndex] ?? 0;

    // Apply monthly balance update once
    globalBalance += (deposit - fees) - settlement;

    // Protect next month liquidity
    let nextMonthReserve = 0;
    if (monthIndex + 1 < maxMonths) {
      const nd = monthlyDeposit[monthIndex + 1] ?? monthlyDeposit[0] ?? 0;
      const ns = monthlySettlement[monthIndex + 1] ?? 0;
      const nf = monthlyFees[monthIndex + 1] ?? 0;

      const shortfall = (ns + nf) - nd;
      if (shortfall > 0) nextMonthReserve = shortfall;
    }

    let availableForFees = Math.max(globalBalance - nextMonthReserve, 0);
    if (availableForFees <= 0) continue;

    const sortedDebts = sortDebts();

    for (const debt of sortedDebts) {
      if (availableForFees <= 0 || debt.pendingFee <= 0) continue;

      const payment = Math.min(debt.pendingFee, availableForFees);

      debt.pendingFee = +(debt.pendingFee - payment).toFixed(2);
      availableForFees = +(availableForFees - payment).toFixed(2);
      globalBalance = +(globalBalance - payment).toFixed(2);

      const scheduledDate = new Date(today);
      scheduledDate.setMonth(today.getMonth() + monthIndex);

      debt.feeLog.push({
        debtId: debt.debtId,
        creditor: debt.creditorName,
        month: monthIndex + 1,
        feeCollected: payment,
        remainingFee: debt.pendingFee,
        remainingBalance: globalBalance,
        scheduleDate: scheduledDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }),
        scheduleDateObj: scheduledDate
      });
    }
  }

  return debts
    .filter(d => d.feeLog.length > 0)
    .map(d => ({
      debtId: d.debtId,
      creditor: d.creditorName,
      scheduledFee: parseFloat(d.scheduledFee || 0),
      pendingFee: parseFloat(d.pendingFee || 0),
      feeSchedule: d.feeLog
    }));
};


// VERSION 2 MULTIPLE EPF - COMPUTES DATA FROM DATA TRANSACTION BASED AND FORECASTING
const recalculateFees = (feeCollectionType) => {
    const maxMonths = 60;
    const now = new Date();
    let counterID = 1;

    const round2 = v => Number((Number(v) || 0).toFixed(2));

    const formatISODate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };

    const normalizeBalances = (log) =>
        log.map(t => ({
            ...t,
            ForecastEndingBalance: round2(t.ForecastEndingBalance)
        }));

    // Sum future non-EPF credits for this specific debt
    const sumNextIncomingCredits = (log, startIndex, debtID) => {
        let sum = 0;
        for (let i = startIndex; i < log.length; i++) {
            const t = log[i];
            if (t.Type === "Debit" || t.Type === "Deposit") break;
            if (
                t.Type === "Credit" &&
                t.TransactionTitle !== "Earned Performance Fee" &&
                t.DebtID === debtID
            ) {
                sum += Number(t.Amount) || 0;
            }
        }
        return round2(sum);
    };

    // Aggressive + safe EPF calculation
    const computeSafeEPFAmount = ({
        fullTransLog,
        insertIndex,
        baseEPF,
        formattedDate,
        debtID
    }) => {
        const creditBuffer = sumNextIncomingCredits(
            fullTransLog,
            insertIndex,
            debtID
        );

        const adjustedBase = Math.max(0, round2(baseEPF - creditBuffer));

        let low = 0;
        let high = adjustedBase;
        let safeAmount = 0;

        while (low <= high) {
            const mid = round2((low + high) / 2);

            const epf = {
                Amount: mid,
                ProcessDate: formattedDate,
                ClearedDate: formattedDate,
                CounterID: counterID,
                DebtID: debtID,
                ForecastEndingBalance: 0,
                OriginalTransactionStatus: "Open",
                TransID: 0,
                TransactionStatus: "SCHEDULED",
                TransactionTitle: "Earned Performance Fee",
                Type: "Credit",
                isDummy: true
            };

            const testLog = [...fullTransLog];
            testLog.splice(insertIndex, 0, epf);

            const recalculated = normalizeBalances(
                recalcForecastBalance(testLog)
            );

            const minBalance = Math.min(
                ...recalculated
                    .slice(insertIndex)
                    .map(t => round2(t.ForecastEndingBalance))
            );

            if (minBalance >= 0) {
                safeAmount = mid;
                low = round2(mid + 0.01);
            } else {
                high = round2(mid - 0.01);
            }
        }

        return round2(safeAmount);
    };

    // Remove all existing EPFs
    let fullTransLog = resultTransEditable.filter(
        t => t.TransactionTitle !== "Earned Performance Fee"
    );

    fullTransLog = normalizeBalances(recalcForecastBalance(fullTransLog));

    // Clone debts
    const debts = data
        .filter(d => round2(d.pendingFee) > 0)
        .map(d => ({
            ...d,
            pendingFee: round2(d.pendingFee),
            feeLog: []
        }));

    const sortDebts = () =>
        [...debts].sort((a, b) => {
            switch (feeCollectionType) {
                case '1': return b.pendingFee - a.pendingFee;
                case '2': return a.pendingFee - b.pendingFee;
                case '3': return String(a.debtId).localeCompare(String(b.debtId));
                case '4': return (a.priority || 0) - (b.priority || 0);
                default: return 0;
            }
        });

    // Build months from current forward
    const months = [...new Set(fullTransLog.map(t => t.YearMonth))]
        .map(m => {
            const [mon, yr] = m.split(" ");
            return { key: m, date: new Date(`${mon} 1, ${yr}`) };
        })
        .filter(m => m.date >= new Date(now.getFullYear(), now.getMonth(), 1))
        .sort((a, b) => a.date - b.date)
        .slice(0, maxMonths);

    // MAIN LOOP
    for (let monthIndex = 0; monthIndex < months.length; monthIndex++) {
        if (debts.every(d => d.pendingFee <= 0)) break;

        const { key: yearMonth, date } = months[monthIndex];
        const monthTxns = fullTransLog.filter(t => t.YearMonth === yearMonth);
        if (!monthTxns.length) continue;

        let lastTxn = monthTxns[monthTxns.length - 1];
        let monthBalance = round2(lastTxn.ForecastEndingBalance);

        const formattedDate = formatISODate(
            new Date(date.getFullYear(), date.getMonth() + 1, 0)
        );

        const sortedDebts = sortDebts();

        for (const debt of sortedDebts) {
            if (debt.pendingFee <= 0) continue;

            const insertIndex = fullTransLog.lastIndexOf(lastTxn) + 1;

            // 🔥 Aggressive: ask for full remaining fee
            const safeFee = computeSafeEPFAmount({
                fullTransLog,
                insertIndex,
                baseEPF: debt.pendingFee,
                formattedDate,
                debtID: debt.debtId
            });

            const epf = {
                Amount: safeFee,
                ProcessDate: formattedDate,
                ClearedDate: formattedDate,
                CounterID: counterID++,
                DebtID: debt.debtId,
                ForecastEndingBalance: 0,
                OriginalTransactionStatus: "Open",
                TransID: 0,
                TransactionStatus: "SCHEDULED",
                TransactionTitle: "Earned Performance Fee",
                Type: "Credit",
                YearMonth: yearMonth,
                isDummy: true
            };

            fullTransLog.splice(insertIndex, 0, epf);
            fullTransLog = normalizeBalances(recalcForecastBalance(fullTransLog));

            debt.pendingFee = round2(debt.pendingFee - safeFee);

            lastTxn = fullTransLog
                .filter(t => t.YearMonth === yearMonth)
                .slice(-1)[0];

            monthBalance = round2(lastTxn.ForecastEndingBalance);

            debt.feeLog.push({
                debtId: debt.debtId,
                creditor: debt.creditorName,
                month: monthIndex + 1,
                feeCollected: safeFee,
                remainingFee: debt.pendingFee,
                remainingBalance: monthBalance,
                scheduleDate: new Date(formattedDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                }),
                scheduleDateObj: new Date(formattedDate)
            });
        }
    }

    return debts
        .filter(d => d.feeLog.length > 0)
        .map(d => ({
            debtId: d.debtId,
            creditor: d.creditorName,
            scheduledFee: round2(d.scheduledFee || 0),
            pendingFee: round2(d.pendingFee),
            feeSchedule: d.feeLog
        }));
};

  const getDebtDetailsTransactionsWDebtID  = () => {
    if (!selectedDebt) return [];

    const debtID = selectedDebt.debtId; 
    const debtDetailedTransWDebtID = transactionDataWDebtID;
    const transLog = [];

    let itemNoCounter = 1;

    for (let m = 0; m < debtDetailedTransWDebtID.length; m++) {
      //alert(debtDetailedTrans[m].DebtId);
      if (debtDetailedTransWDebtID[m].DebtId  === debtID) {
        const formattedDateScheduleDateAdjusted = debtDetailedTransWDebtID[m].ScheduleDateAdjusted ? debtDetailedTransWDebtID[m].ScheduleDateAdjusted.split('T')[0] : 'N/A';
        transLog.push({
          TransCounterID: itemNoCounter++,
          ID: debtDetailedTransWDebtID[m].ID,
          TransactionDate: formattedDateScheduleDateAdjusted,
          TableName: debtDetailedTransWDebtID[m].TransactionTitle,
          Amount: debtDetailedTransWDebtID[m].Amount,
          Type: debtDetailedTransWDebtID[m].Type,
          OrigTransactionStatus: debtDetailedTransWDebtID[m].OriginalTransStatus,
          TransactionStatus: debtDetailedTransWDebtID[m].TransactionType,
          SubTypeName : debtDetailedTransWDebtID[m].SubTypeName
          });
      }
    } 

    return transLog;
  };

  const [resultTrans, setResultTrans] = useState([]);
    
  const getDebtDetailsAllTransactions = (debtDetailedTrans) => {
      const transLog = [];
      let counterID = 1;

      // ✅ Step 1: Sort input array by ScheduleDateAdjusted (ClearedDate)
      const sortedDebtTrans = [...debtDetailedTrans].sort((a, b) => {
        const dateA = a.ScheduleDateAdjusted ? new Date(a.ScheduleDateAdjusted) : new Date(0); // fallback for nulls
        const dateB = b.ScheduleDateAdjusted ? new Date(b.ScheduleDateAdjusted) : new Date(0);
        return dateA - dateB; // ascending order
      });

      // ✅ Step 2: Process sorted data
      for (let m = 0; m < sortedDebtTrans.length; m++) {
        const item = sortedDebtTrans[m];

        const formattedDateScheduleDateOriginal = item.ScheduleDateOriginal
          ? item.ScheduleDateOriginal.split('T')[0]
          : 'N/A';

        const formattedDateScheduleDateAdjusted = item.ScheduleDateAdjusted
          ? item.ScheduleDateAdjusted.split('T')[0]
          : 'N/A';

        transLog.push({
          CounterID: counterID++,
          DebtID: item.DebtId,
          TransID: item.ID,
          ProcessDate: formattedDateScheduleDateOriginal,
          ClearedDate: formattedDateScheduleDateAdjusted,
          TransactionTitle: item.TransactionTitle,
          Amount: item.Amount,
          Type: item.Type,
          OriginalTransactionStatus: item.OriginalTransStatus,
          TransactionStatus: item.TransactionStatus,
          CurrentEndingBalance: item.CurrentRunningTotal,
          ForecastEndingBalance: item.ForecastRunningTotal,
          SubTypeName : item.SubTypeName,
          StatusBySched : item.StatusBySched
        });
      }
      console.log("Get Data for All Transactions",transLog);
      return transLog;   
  };


  const [resultTransEditable, setResultTransEditable] = useState([]);

  const getDebtDetailsAllTransactionsEditable = (debtDetailedTrans) => {
    const transLog = [];
    let counterID = 1;
    let balance = accountBalData; // Starting forecast balance

    // ✅ Step 1: Filter unnecessary
    const filteredTransLog = debtDetailedTrans.filter(item =>
      item.TransactionStatus !== "COMPLETED" &&
      item.TransactionStatus !== "CANCELLED" &&
      (item.OriginalTransactionStatus !== "Stop Payment" ||
      item.OriginalTransactionStatus !== "Returned / NSF" ||
      item.OriginalTransactionStatus !== "Cancel" ||
      //item.OriginalTransactionStatus !== "Unauth Return" ||  // removed this 21JAN2026 as per mylene
      item.OriginalTransactionStatus !== "Void" ||
      item.OriginalTransactionStatus !== "Error Processing" ||
      item.OriginalTransactionStatus !== "Rejected" ||
      item.OriginalTransactionStatus !== "Reversed") //&&
      //(item.TransactionTitle === "Earned Performance Fee" && item.DebtID === debtID)
    );

    // ✅ Step 2: Sort by adjusted schedule date
    const sortedDebtTrans = [...filteredTransLog].sort((a, b) => {
      const dateA = a.ScheduleDateAdjusted ? new Date(a.ScheduleDateAdjusted) : new Date(0);
      const dateB = b.ScheduleDateAdjusted ? new Date(b.ScheduleDateAdjusted) : new Date(0);
      return dateA - dateB;
    });

    // ✅ Step 3: Process sorted data and recompute forecast running balance
    for (let m = 0; m < sortedDebtTrans.length; m++) {
      const item = sortedDebtTrans[m];

      const statusNoImpact = noImpactStatuses.includes(item.OriginalTransactionStatus);

      // Apply balance only if the transaction is NOT in no-impact list
      if (!statusNoImpact) {
        if (item.Type?.toLowerCase() === "credit") {
          balance -= Number(item.Amount);
        } else if (item.Type?.toLowerCase() === "debit") {
          balance += Number(item.Amount);
        }
      }

      const formattedDateScheduleDateAdjustedYearMonth = (() => {
        if (!item.ScheduleDateAdjusted) return 'N/A';

        const datePart = item.ScheduleDateAdjusted.split('T')[0];
        const [year, month] = datePart.split('-');

        const monthNames = [
          'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
          'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
        ];

        return `${monthNames[parseInt(month) - 1]} ${year}`;
      })();

      const formattedDateScheduleDateOriginal = item.ScheduleDateOriginal
        ? item.ScheduleDateOriginal.split('T')[0]
        : 'N/A';

      const formattedDateScheduleDateAdjusted = item.ScheduleDateAdjusted
        ? item.ScheduleDateAdjusted.split('T')[0]
        : 'N/A';

      // ➤ Push updated transaction into log
      transLog.push({
        CounterID: counterID++,
        DebtID: item.DebtId,
        TransID: item.ID,
        YearMonth: formattedDateScheduleDateAdjustedYearMonth,
        ProcessDate: formattedDateScheduleDateOriginal,
        ClearedDate: formattedDateScheduleDateAdjusted,
        TransactionTitle: item.TransactionTitle,
        SubTypeName: item.SubTypeName,
        Amount: item.Amount,
        Type: item.Type,
        OriginalTransactionStatus: item.OriginalTransStatus,
        TransactionStatus: item.TransactionStatus,
        //ForecastEndingBalance: balance, // <<< Updated with recalculated running balance
        ForecastEndingBalance: item.ForecastRunningTotal,  // Show same forcast ending balance based from All transactions
      });
    }

    // setResultTransEditable(transLog);
     console.log("Set Data for Trans Editable: ",transLog);

    return transLog;
  };

  const getDebtDetailsAllTransactionsEditableUpdated = (debtDetailedTrans) => {
    const transLog = [];
    // ✅ Step 1: Filter unnecessary
    const filteredTransLog = debtDetailedTrans.filter(item =>
      item.TransactionStatus !== "COMPLETED" &&
      item.TransactionStatus !== "CANCELLED" &&
      (item.OriginalTransactionStatus !== "Stop Payment" ||
      item.OriginalTransactionStatus !== "Returned / NSF" ||
      item.OriginalTransactionStatus !== "Cancel" ||
      //item.OriginalTransactionStatus !== "Unauth Return" || // removed this 21JAN2026 as per mylene
      item.OriginalTransactionStatus !== "Error Processing" ||
      item.OriginalTransactionStatus !== "Rejected" ||
      item.OriginalTransactionStatus !== "Void" ||
      item.OriginalTransactionStatus !== "Reversed") //&&
      //(item.TransactionTitle === "Earned Performance Fee" && item.DebtID === debtID)
    );

    // ✅ Step 2: Sort by adjusted schedule date
    const sortedDebtTrans = [...filteredTransLog].sort((a, b) => {
      const dateA = a.ClearedDate ? new Date(a.ClearedDate) : new Date(0);
      const dateB = b.ClearedDate ? new Date(b.ClearedDate) : new Date(0);
      return dateA - dateB;
    });

    // ✅ Step 3: Process sorted data and recompute forecast running balance
    for (let m = 0; m < sortedDebtTrans.length; m++) {
      const item = sortedDebtTrans[m];

      // ➤ Push updated transaction into log
      transLog.push({
        CounterID: item.CounterID,
        DebtID: item.DebtID,
        TransID: item.TransID,
        YearMonth: item.YearMonth,
        ProcessDate: item.ProcessDate,
        ClearedDate: item.ClearedDate,
        TransactionTitle: item.TransactionTitle,
        SubTypeName: item.SubTypeName,
        Amount: item.Amount,
        Type: item.Type,
        OriginalTransactionStatus: item.OriginalTransStatus,
        TransactionStatus: item.TransactionStatus,
        ForecastEndingBalance: item.ForecastEndingBalance,
      });
    }
    return transLog;
  };
  
  const recalcForecastBalance = (data) => {
    let balance = accountBalData;

    // Sort by adjusted schedule date
    const sorted = [...data].sort((a, b) =>
      new Date(a.ScheduleDateAdjusted) - new Date(b.ScheduleDateAdjusted)
    );

    return sorted.map(item => {
      const noImpact = noImpactStatuses.includes(item.OriginalTransactionStatus);

      if (!noImpact) {
        if (item.Type?.toLowerCase() === "credit") balance -= Number(item.Amount);
        if (item.Type?.toLowerCase() === "debit") balance += Number(item.Amount);
      }

      return {
        ...item,
        ForecastEndingBalance: balance
      };
    });
  };
  const getDebtDetailsAllTransactionsEditableFilteredByMonth = (monthYear) => {
      if (!monthYear) return [];

      // Convert to uppercase to avoid case sensitivity problems
      const filterKey = monthYear.toUpperCase();  // e.g. "JAN 2025"
     
      // Filter by YearMonth field ("JAN 2025")
      const filtered = resultTransEditable.filter(item => item.YearMonth === filterKey);
      
      console.log("Get Filtered Data By Month Year: " , filtered);
      
      return filtered;
  };
  
  const parseScheduleDateToYearMonth = (scheduleDate) => {
    if (!scheduleDate) return null;

    // scheduleDate is like "Dec 25, 2024"
    const parts = scheduleDate.split(' ');
    if (parts.length < 3) return null;

    const month = parts[0].toUpperCase(); // "DEC"
    const year = parts[2]; // "2024"

    return `${month} ${year}`; // "DEC 2024"
  };


  const computeDebitCreditTotals = (transactions) => {
  let totalDebit = 0;
  let totalCredit = 0;

  transactions.forEach(item => {
    const amount = Number(item.Amount) || 0;

    if (item.Type?.toUpperCase() === "DEBIT") {
      totalDebit += amount;
    } else if (item.Type?.toUpperCase() === "CREDIT") {
      totalCredit += amount;
    }
  });

  return { totalDebit, totalCredit };
};

  const [results, setResults] = useState([]);
  const [tabresults, setTabResults] = useState([]);
  const [tabResultsByMonthYear, setTabResultsByMonthYear] = useState([]);

    // Automatically populate tabresults when Transaction Details modal opens
    useEffect(() => {
      if (isModalTransactionOpen && selectedDebt) {
        const allocation = getDebtDetailsTransactionsWDebtID();
        setTabResults(allocation);
      }
    }, [isModalTransactionOpen, selectedDebt]);

  
    const handleClick = () => {
      // const allocation = calculateFeeAllocation();
      // setResults(allocation);
      Swal.fire({
              title: "Processing...",
              text: `Sample`,
              timer: 1500,
              showConfirmButton: false,
              willClose: () => {}, // optional callback
              })
    };
    
    // const handleClickTransactionsWDebtID = () => {
    //   const allocation = getDebtDetailsTransactionsWDebtID();
    //   setTabResults(allocation);
    // };

    const handleClickFeeRecalculation = () => {
      const allocation = calculateFeeAllocation();
      setResults(allocation);
    };

    const handleClickFeesRecalculation = () => {
      const allocation = recalculateFees(feeCollectionType);
      setResults(allocation);
    };


    

  const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;
  
    return (
      <div className="calcu-modal-overlay">
        <div className="modal modal-md">
          <button className="modal-close" onClick={onClose}>×</button>
          <div className="modal-content">{children}</div>
        </div>
      </div>
    );
  };

  // Check for client-id continuously until it is found
  useEffect(() => {
  const observeChanges = () => {
    const cftidElement = document.getElementById('client-id');
    const dmidElement = document.getElementById('external-id');
    const forthidElement = document.getElementById('contact-id');
    const balanceIdElement = document.getElementById('balance-id');

    const getValidClientId = () => {
      const cftid = cftidElement?.innerText.trim();
      const dmid = dmidElement?.innerText.trim();
      const forthid = forthidElement?.innerText.trim();

      const ids = [forthid, cftid, dmid];
      return ids.find(id => id && id !== '0' && id !== 0) || 0;
    };

    const handleChange = () => {
      const foundClientid = getValidClientId();

      if (foundClientid && foundClientid !== '0') {
        setClientid(foundClientid);

        if (balanceIdElement) {
          const foundBalance = Number(
            balanceIdElement.innerText.trim().replace('$', '').replace(/,/g, '')
          );
          setAccountBalData(foundBalance);
        }
      }
    };

    const observer = new MutationObserver(handleChange);
    const config = { childList: true, subtree: true, characterData: true };

    if (cftidElement) observer.observe(cftidElement, config);
    if (dmidElement) observer.observe(dmidElement, config);
    if (forthidElement) observer.observe(forthidElement, config);

    return () => {
      observer.disconnect(); // Clean up when component unmounts
    };
  };

  observeChanges();
}, []);


 


  // Fetch data once the client-id is available
  useEffect(() => {
    if (!clientid || clientid === '0') return; // Do not fetch until clientid is found
    
      const fetchData = async () => {
        try {
          //setLoading(true);
          setIsVisible(true); // Show loading data section

          const [validateRes,  transResWDebtID, allTransactions, clientListWDiscrepancy] = await Promise.all([
            fetch(`https://eowyuuwbymur1qh.m.pipedream.net/api/CompletionCalculator/GetDebtSummaryByClientID?clientid=${clientid}`),
            fetch(`https://eof63fgy05970e.m.pipedream.net/api/CompletionCalculator/GetDebtDetailsByClientID?clientid=${clientid}`),
            fetch(`https://eolcj0ctbgto81.m.pipedream.net/api/PaymentChangeCalculator/GetAllTransactionsByClientID?clientid=${clientid}`),
            fetch(`https://eokfi3ku7k229kt.m.pipedream.net/api/EPFRebalancer/CheckClientListWithDataDiscrepancy?clientid=${clientid}`)
          ]);
  
          const validateData = await validateRes.json();
          // const depositData = await depositRes.json();
          // const settlementData = await settlementRes.json();
          // const feesData = await feesRes.json();
          //const balanceData = await balanceRes.json();
          const transactionWDebtIdData =  await transResWDebtID.json();
          const allTransactionsData =  await allTransactions.json();
          const allClientListWithDataDiscrepancyData =  await clientListWDiscrepancy.json();

          setData(validateData);
          // setDepositData(depositData);
          // setSettlementData(settlementData);
          // setFeesData(feesData);
          //setAccountBalData(balanceData);
          setTransactionDataWDebtID(transactionWDebtIdData);
          setAllTransactionData(allTransactionsData);

          const allocationAllTransactions = getDebtDetailsAllTransactions(allTransactionsData);
          setResultTrans(allocationAllTransactions);

          const allocationAllTransactionsEditable = getDebtDetailsAllTransactionsEditable(allTransactionsData);
          setResultTransEditable(allocationAllTransactionsEditable);

          checkPendingScheduledTransactions(allocationAllTransactionsEditable);

          checkClientifWithDataDiscrepancy(allClientListWithDataDiscrepancyData);

        } catch (err) {
            setError(err);
            Swal.fire({
              icon: "error",
              title: "We're unable to get the debt summary data.",
              text: "Kindly contact PDR Support for assistance.",
              confirmButtonColor: '#A5CC2D', 
            });
        } finally {
        }
  
        setIsVisible(false); // Show loading data section
      };
  
      fetchData();
  }, [clientid]); // Trigger when clientid changes

  
  const totalFees = data.reduce((acc, curr) => acc + Number(curr.pendingFee || 0), 0);
  const totalPayment = data.reduce((acc, curr) => acc + Number(curr.pendingPayment || 0), 0);


  const checkPendingScheduledTransactions = (transactions) => {
    console.log("Set up past pending/schedule: ", transactions);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isPastMonth = (date) => {
      const now = new Date();
      return (
        date.getFullYear() < now.getFullYear() ||
        (date.getFullYear() === now.getFullYear() && date.getMonth() < now.getMonth())
      );
    };

    const pastScheduledPending = transactions.filter(trans => {
      const status = trans.TransactionStatus?.toUpperCase();

      // FIXED LOGIC
      if (status !== "SCHEDULED" && status !== "PENDING") return false;

      if (!trans.ClearedDate || trans.ClearedDate === "N/A") return false;

      const clearedDate = new Date(trans.ClearedDate);
      const isPast = isPastMonth(clearedDate);

      return isPast ;
    });

    if (pastScheduledPending.length > 0) {
      const tableRows = pastScheduledPending.map(trans => `
        <tr>
          <td>${trans.CounterID}</td>
          <td>${trans.DebtID}</td>
          <td>${trans.TransID}</td>
          <td>${trans.TransactionTitle}</td>
          <td>${trans.ProcessDate}</td>
          <td>${trans.ClearedDate}</td>
          <td>${formatCurrencyUSD(Number(trans.Amount).toFixed(2))}</td>
          <td>${trans.OriginalTransactionStatus}</td>
          <td>${trans.TransactionStatus}</td>
        </tr>
      `).join('');

      const tableHTML = `
        <table border="1" cellpadding="8" cellspacing="0" style="border-collapse: collapse; width: 100%; text-align: left;">
          <thead>
            <tr style="background-color: #f0f0f0;">
              <th>Item #</th>
              <th>Debt ID</th>
              <th>Trans ID</th>
              <th>Transaction</th>
              <th>Process Date</th>
              <th>Cleared Date</th>
              <th>Amount</th>
              <th>Original Status</th>
              <th>Overall Status</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
      `;

      Swal.fire({
        icon: 'warning',
        title: 'Past Scheduled / Pending Transaction Alert',
        html: `
          <p>The following past scheduled/pending transactions might affect EPF Recalculation:</p>
          ${tableHTML}
        `,
        confirmButtonColor: '#A5CC2D',
        customClass: { popup: 'custom-swal-width' }
      });
    }
  };

  const checkClientifWithDataDiscrepancy = (clients) => {

    if(clients.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Client with Data Discrepancy',
        html: `
          <p>This client has a known data discrepancy issue with Forth. It may affect EPF recalculation. Proceed with caution.</p>
        `,
        confirmButtonColor: '#A5CC2D'
      });
    }
  };

  // // If loading, show a loading message
  // if (loading) return <div className="info-badge">Loading...</div>;

  // // If there's an error, show an error message
  // if (error) return <div className="danger-badge">Unable to load Scheduled Transactions: {error}</div>;

  // Function to handle sorting
  const handleSort = (column) => {
    const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortDirection(newDirection);
    setSortColumn(column);

    const sortedData = [...data].sort((a, b) => {
      if (newDirection === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });

    setData(sortedData);
  };

   useEffect(() => {
    const uniqueTrans = [...new Set(resultTrans.map(r => r.TransactionTitle).filter(Boolean))];
    console.log("Setting uniqueTableNames:", uniqueTrans);
    setUniqueTableNames(uniqueTrans);
  }, [resultTrans]);

  useEffect(() => {
    let filtered = resultTrans;
    if (selectedTableNameFilter.length > 0) {
      filtered = filtered.filter(r => selectedTableNameFilter.includes(r.TransactionTitle));
    }
    if (selectedStatusFilter.length > 0) {
      filtered = filtered.filter(r => selectedStatusFilter.includes(r.TransactionStatus));
    }
    if (selectedDebtIdFilter.length > 0) {
      filtered = filtered.filter(r => selectedDebtIdFilter.includes(r.DebtID));
    }
    filtered = filterByDateRange(filtered, dateFrom, dateTo);
    console.log("Setting combined filtered data:", filtered);
    setSortedData(filtered);
  }, [selectedTableNameFilter,selectedDebtIdFilter, selectedStatusFilter, dateFrom, dateTo, resultTrans]);


  useEffect(() => {

    const uniqueStats= [...new Set(resultTrans.map(r => r.TransactionStatus).filter(Boolean))];
    console.log("Setting uniqueStatuses:", uniqueStats);
    setUniqueStatuses(uniqueStats);
  }, [resultTrans]);

  useEffect(() => {

    const uniqueDebtId= [...new Set(resultTrans.map(r => r.DebtID).filter(Boolean))];
    console.log("Setting uniqueDebtIds:", uniqueDebtId);
    setUniqueDebtIds(uniqueDebtId);
  }, [resultTrans]);

  useEffect(() => {
    if (selectedTableNameFilter.length === 0) {
      setFilteredUniqueStatuses(uniqueStatuses);
    } else {
      const filtered = resultTrans
        .filter(r => selectedTableNameFilter.includes(r.TransactionTitle))
        .map(r => r.TransactionStatus)
        .filter(Boolean);
      const uniqueFiltered = [...new Set(filtered)];
      setFilteredUniqueStatuses(uniqueFiltered);
    }
  }, [selectedTableNameFilter, resultTrans, uniqueStatuses]);

  return (
    <div className="debt-summary-trans-table">
      <div className="flex-container">
        <div className="column">
          <label className="container-headtitle">Debt Summary</label>
          <select
            className="form-control ddl"
            style={{
              width: '200px'
            }}
            id="ddl-calculator-type"
            value={calculatorType}
            onChange={(e) => setCalculatorType(e.target.value)}
          >
            <option value="1">EPF Rebalancer</option>
            {/* <option value="2">Settlement Calculator</option> */}
          </select>
          {calculatorType === "1" && (
            <select
              className="form-control ddl"
              style={{
                width: '250px'
              }}
              id="ddl-fee-collection-type"
              value={feeCollectionType}
              //onChange={(e) => setFeeCollectionType(e.target.value)}
              onChange={(e) => {
                const selectedValue = e.target.value;
                setFeeCollectionType(selectedValue);
                //const recalculated = recalculateFees(selectedValue);
                //setResults(recalculated);
              }}
            >
              <option value="1">Collect Highest Fee</option>
              <option value="2">Collect Lowest Fee</option>
              <option value="3">Collect Equal Fee</option>
              <option value="4">Collect Priority Fee</option>
            </select>
          )}

          {calculatorType === "1" && (
            <button
              id="btn-recalculate-multiple-fees"
              onClick={() => {
                //setSelectedDebt(item);
                setIsModalRecalculationFeesOpen(true);
                setResults([]);
              }}
              disabled="disabled"
              className="btn btn-secondary"
            >
              Recalculate Fees
            </button>
          )}
          {isVisible && (<span className="spinner"></span>)}
          <br />


          <div className="dashboard">
            <div className="flex-container">
                <div className="column">
                    <label className="container-title">Total Fee Outstanding</label>
                    {isVisible && (<span className="spinner"></span>)}
                    <label 
                    className="container-count" 
                    style={{
                        color: data.Balance < 0? 'red' : 'green',
                        }}
                    >{formatCurrencyUSD(Number(totalFees.toFixed(2)))}</label>
                </div>
                <div className="column">
                    <label className="container-title">Total Payment Outstanding</label>
                    {isVisible && (<span className="spinner"></span>)}
                    <label 
                    className="container-count" 
                    style={{
                        color: data.Balance < 0? 'red' : 'green',
                        }}
                    >{formatCurrencyUSD(Number(totalPayment.toFixed(2)))}</label>
                </div>
            </div>
          </div>
          <br />
          <br />
            
          <div className="table-container table-lg">
            <table className="table-bordered scrollable-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('ID')}>
                    Debt ID {sortColumn === 'ID' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('CreditorAccountNumber')}>
                    Account Number
                    {sortColumn === 'CreditorAccountNumber' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('Creditor')}>
                  Creditor {sortColumn === 'Creditor' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('Percentage')}>
                  Fee % {sortColumn === 'Percentage' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('SettlementAmount')}>
                  Settlement Amount {sortColumn === 'SettlementAmount' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('CollectedPayment')}>
                  Collected Payment {sortColumn === 'CollectedPayment' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('PendingPayment')}>
                  Pending Payment {sortColumn === 'PendingPayment' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('TotalSettlementFee')} title="Collectable Fee">
                  Total Settlement Fee{sortColumn === 'TotalSettlementFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('EPFPaid ')}  title="Collected Fee">
                  EPF Paid {sortColumn === 'EPFPaid' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th onClick={() => handleSort('EPFremaining ')}  title="Scheduled and Pending Fee">
                  EPF Remaining  {sortColumn === 'EPFremaining' && (sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th> Action </th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item) => {
                    
                    // const totalFees =+ item.pendingFee;
                    // const totalPayment =+ item.pendingPayment;
                    return (
                      <tr key={item.debtId}
                        style={{
                            backgroundColor:
                              item.settlementAmount > 0
                                ? '#ffeaeaff'      
                                : 'inherit',
                          }}
                      >
                        <td>{item.debtId}</td>
                        <td>{item.accountNumber}</td>
                        {/* <td>{item.creditorId}</td> */}
                        <td>{item.creditorName}</td>
                        <td>{item.feePercent}%</td>
                        <td style={{ color: Number(item.settlementAmount) > 0 ? "green" : "#828282" }}>{formatCurrencyUSD(Number(item.settlementAmount || 0).toFixed(2))}</td>
                        <td style={{ color: Number(item.collectedPayment) > 0 ? "green" : "#828282" }}>{formatCurrencyUSD(Number(item.collectedPayment || 0).toFixed(2))}</td>
                        <td style={{ color: Number(item.pendingPayment) > 0 ? "red" : "#828282" }}>{formatCurrencyUSD(Number(item.pendingPayment || 0).toFixed(2))}</td>
                        <td style={{ color: Number(item.collectableFee) > 0 ? "green" : "#828282" }}>{formatCurrencyUSD(Number(item.collectableFee || 0).toFixed(2))}</td>
                        <td style={{ color: Number(item.collectedFee) > 0 ? "green" : "#828282" }}>{formatCurrencyUSD(Number(item.collectedFee || 0).toFixed(2))}</td>
                        <td style={{ color: Number(item.pendingFee) > 0 ? "red" : "#828282" }}>{formatCurrencyUSD(Number(item.pendingFee || 0).toFixed(2))}</td>
                        <td className="td-flex">
                          <button
                              id="btn-view"
                              onClick={() => {
                                setSelectedDebt(item);
                                setIsModalTransactionOpen(true);
                                setResults([]);
                              }}
                              className="btn btn-custom"
                              title="View Transactions"
                            >
                              📄
                          </button>
                          {calculatorType === "1" && (
                            <button
                              id="btn-recalculate-fee"
                              onClick={() => {
                                setSelectedDebt(item);
                                setIsModalRecalculationFeeOpen(true);
                                setResults([]);
                              }}
                              className="btn btn-custom"
                              title="Recalculate Earned Performance Fee - Remaining"
                              disabled={Number(item.pendingFee)<= 0}
                            >
                              🔢
                            </button>
                          )}

                          {/* {calculatorType === "2" && (
                            <button
                              id="btn-settlement"
                              onClick={() => {
                                setSelectedDebt(item);
                                setIsModalRecalculationSettlementOpen(true);
                                setResults([]);
                              }}
                              className="btn btn-secondary btn-sm"
                            >
                              Recalculate Settlement
                            </button>
                          )} */}

                          <Modal isOpen={isModalTransactionOpen} onClose={() => setIsModalTransactionOpen(false)}>
                            <h2>Transaction Details</h2>
                            <hr/>
                            <label>ℹ️ Transaction Details for the selected Debt ID or Creditor are shown below.</label><br/>
                            <label>ℹ️ Each tab displays the transactions associated with the selected Debt ID, categorized by Transaction Status.</label>
                            <br/><br/><br/>
                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                   <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> EPF Remaining </th>
                                    <th> Savings Account Balance </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{selectedDebt?.debtId}</td>
                                    <td>{selectedDebt?.accountNumber}</td>
                                    <td>{selectedDebt?.creditorName}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.pendingFee || 0).toFixed(2))}</td>
                                    <td>
                                        <span 
                                            style={{
                                            color:
                                                accountBalData < 0
                                                ? 'red'
                                                : 'green',
                                            }}
                                        >
                                        {formatCurrencyUSD(Number(accountBalData || '0.00').toFixed(2))}
                                        </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            {/* <button className="btn btn-secondary"  onClick={handleClickTransactionsWDebtID} >View Details</button> */}
                            <br/><br/>
                             <Box sx={{ width: '100%' }}>
                              <Tabs value={valueTrans} onChange={handleChangeTrans} aria-label="basic tabs">
                                <Tab label="Completed" />
                                <Tab label="Scheduled" />
                                <Tab label="Pending" />
                                <Tab label="Cancelled" />
                                {/* <Tab label="Tab Three" /> */}
                              </Tabs>
                              <TabPanel value={valueTrans} index={0}>
                                 <div className="table-container table-sm">
                                    {tabresults.length > 0 && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Item ID</th>
                                            <th>Trans ID</th>
                                            <th>Transaction Date</th>
                                            <th>Transaction</th>
                                            <th>Sub Type</th>
                                            <th>Amount</th>
                                            <th>Original Status</th>
                                            <th>Overall Status</th>
                                            
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {tabresults.length > 0 ? (
                                              tabresults
                                                .filter((row) => row.TransactionStatus === "COMPLETED")
                                                .map((row) => (
                                                  <tr key={row.TransCounterID}>
                                                    <td>{row.TransCounterID || 'N/A'}</td>
                                                    <td>{row.ID || 'N/A'}</td>
                                                    <td>{row.TransactionDate || 'N/A'}</td>
                                                    <td>{row.TableName || 'N/A'}</td>
                                                    <td>{row.SubTypeName || 'N/A'}</td>
                                                    <td>
                                                        <span
                                                        style={{
                                                            color: row.Type === "credit" || row.Type === "Credit" ? 'red' : 'green',
                                                        }}
                                                        >
                                                        {row.Type === "credit"  || row.Type === "Credit" ? '-' : '+'} {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                                        </span>
                                                    </td>
                                                    <td>{row.OrigTransactionStatus || 'N/A'}</td>
                                                    <td>
                                                      <span
                                                        className="badge"
                                                        style={{
                                                        backgroundColor:
                                                            row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                                            ? '#b7ffd8ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                                            ? '#ffebb7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                                            ? '#ffb7b7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'CANCELLED'
                                                            ? '#ddddddff'
                                                            : 'inherit',
                                                        }}
                                                    >
                                                        {row.TransactionStatus || 'N/A'}
                                                    </span>
                                                    </td>
                                                    
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                              </TabPanel>
                              <TabPanel value={valueTrans} index={1}>
                                <div className="table-container table-sm">
                                    {tabresults.length > 0  && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Item ID</th>
                                            <th>Trans ID</th>
                                            <th>Transaction Date</th>
                                            <th>Transaction</th>
                                            <th>Sub Type</th>
                                            <th>Amount</th>
                                            <th>Original Status</th>
                                            <th>Overall Status</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          
                                          {tabresults.length > 0 ? (
                                              tabresults
                                                .filter((row) => row.TransactionStatus === "SCHEDULED")
                                                .map((row) => (
                                                  <tr key={row.TransCounterID}>
                                                    <td>{row.TransCounterID || 'N/A'}</td>
                                                    <td>{row.ID || 'N/A'}</td>
                                                    <td>{row.TransactionDate || 'N/A'}</td>
                                                    <td>{row.TableName || 'N/A'}</td>
                                                    <td>{row.SubTypeName || 'N/A'}</td>
                                                    <td>
                                                        <span
                                                        style={{
                                                            color: row.Type === "credit" || row.Type === "Credit" ? 'red' : 'green',
                                                        }}
                                                        >
                                                        {row.Type === "credit" || row.Type === "Credit" ? '-' : '+'} {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                                        </span>
                                                    </td>
                                                    <td>{row.OrigTransactionStatus || 'N/A'}</td>
                                                    <td>
                                                      <span
                                                        className="badge"
                                                        style={{
                                                        backgroundColor:
                                                            row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                                            ? '#b7ffd8ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                                            ? '#ffebb7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                                            ? '#ffb7b7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'CANCELLED'
                                                            ? '#ddddddff'
                                                            : 'inherit',
                                                        }}
                                                        >
                                                            {row.TransactionStatus || 'N/A'}
                                                        </span>
                                                    </td>                                                    
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                              </TabPanel>
                              <TabPanel value={valueTrans} index={2}>
                                <div className="table-container table-sm">
                                    {tabresults.length > 0  && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Item ID</th>
                                            <th>Trans ID</th>
                                            <th>Transaction Date</th>
                                            <th>Transaction</th>
                                            <th>Sub Type</th>
                                            <th>Amount</th>
                                            <th>Original Status</th>
                                            <th>Overall Status</th>                                            
                                          </tr>
                                        </thead>
                                        <tbody>
                                          
                                          {tabresults.length > 0 ? (
                                              tabresults
                                                .filter((row) => row.TransactionStatus === "PENDING")
                                                .map((row) => (
                                                  <tr key={row.TransCounterID}>
                                                    <td>{row.TransCounterID || 'N/A'}</td>
                                                    <td>{row.ID || 'N/A'}</td>
                                                    <td>{row.TransactionDate || 'N/A'}</td>
                                                    <td>{row.TableName || 'N/A'}</td>
                                                    <td>{row.SubTypeName || 'N/A'}</td>
                                                    <td>
                                                        <span
                                                        style={{
                                                            color: row.Type === "credit" || row.Type === "Credit" ? 'red' : 'green',
                                                        }}
                                                        >
                                                        {row.Type === "credit" || row.Type === "Credit" ? '-' : '+'} {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                                        </span>
                                                    </td>
                                                    <td>{row.OrigTransactionStatus || 'N/A'}</td>
                                                    <td>
                                                      <span
                                                        className="badge"
                                                        style={{
                                                        backgroundColor:
                                                            row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                                            ? '#b7ffd8ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                                            ? '#ffebb7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                                            ? '#ffb7b7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'CANCELLED'
                                                            ? '#ddddddff'
                                                            : 'inherit',
                                                        }}
                                                        >
                                                            {row.TransactionStatus || 'N/A'}
                                                        </span>
                                                    </td>                                                    
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                              </TabPanel>
                              <TabPanel value={valueTrans} index={3}>
                                <div className="table-container table-sm">
                                    {tabresults.length > 0  && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Item ID</th>
                                            <th>Trans ID</th>
                                            <th>Transaction Date</th>
                                            <th>Transaction</th>
                                            <th>Sub Type</th>
                                            <th>Amount</th>
                                            <th>Original Status</th>
                                            <th>Overall Status</th>                                            
                                          </tr>
                                        </thead>
                                        <tbody>
                                          
                                          {tabresults.length > 0 ? (
                                              tabresults
                                                .filter((row) => row.TransactionStatus === "CANCELLED")
                                                .map((row) => (
                                                  <tr key={row.TransCounterID}>
                                                    <td>{row.TransCounterID || 'N/A'}</td>
                                                    <td>{row.ID || 'N/A'}</td>
                                                    <td>{row.TransactionDate || 'N/A'}</td>
                                                    <td>{row.TableName || 'N/A'}</td>
                                                    <td>{row.SubTypeName || 'N/A'}</td>
                                                    <td>
                                                        <span
                                                        style={{
                                                            color: row.Type === "credit" || row.Type === "Credit" ? 'red' : 'green',
                                                        }}
                                                        >
                                                        {row.Type === "credit" || row.Type === "Credit" ? '-' : '+'} {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                                        </span>
                                                    </td>
                                                    <td>{row.OrigTransactionStatus || 'N/A'}</td>
                                                    <td>
                                                      <span
                                                        className="badge"
                                                        style={{
                                                        backgroundColor:
                                                            row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                                            ? '#b7ffd8ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                                            ? '#ffebb7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                                            ? '#ffb7b7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'CANCELLED'
                                                            ? '#ddddddff'
                                                            : 'inherit',
                                                        }}
                                                        >
                                                            {row.TransactionStatus || 'N/A'}
                                                        </span>
                                                    </td>                                                    
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                              </TabPanel>
                              {/* <TabPanel value={value} index={2}>Content for Tab Three</TabPanel> */}
                            </Box>
                           
                         </Modal>

                          <Modal isOpen={isModalRecalculationFeeOpen} onClose={() => setIsModalRecalculationFeeOpen(false)}>
                            <h2>EPF Rebalancer By Creditor / Debt ID</h2>
                            <hr/>
                            <label>🧩 This setup is to recalculate EPF of selected Debt ID or Creditor.</label><br/>
                            
                            <br/><br/><br/>

                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                  <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> EPF Remaining </th>
                                    <th> Savings Account Balance </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{selectedDebt?.debtId}</td>
                                    <td>{selectedDebt?.accountNumber}</td>
                                    <td>{selectedDebt?.creditorName}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.pendingFee || 0).toFixed(2))}</td>
                                    <td>
                                        <span 
                                            style={{
                                            color:
                                                accountBalData < 0
                                                ? 'red'
                                                : 'green',
                                            }}
                                        >
                                        {formatCurrencyUSD(Number(accountBalData || '0.00').toFixed(2))}
                                        </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            
                            
                            <Box sx={{ width: '100%' }}>
                              <Tabs value={valueTransEditable} onChange={handleChangeTransEditable} aria-label="basic tabs">
                                <Tab label="Scheduled Transactions" />
                                <Tab label="Single EPF Recalculation" />

                              </Tabs>

                               <TabPanel value={valueTransEditable} index={0}>
                                  <label>📌 This scheduled / pending transaction list are for simulation.</label><br/>
                                  <label>📌 Selected fields, such as the Original Status (dropdown), are editable for simulation. When changed, the related columns and amounts are automatically updated.</label><br/><br/><br/>
                                  <div className="table-container table-sm">
                                    {resultTransEditable.length > 0 && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Item #</th>
                                            <th>Debt ID</th>
                                            <th>Trans ID</th>
                                            <th>Process Date</th>
                                            <th>Cleared Date</th>
                                            <th>Year Month</th>
                                            <th>Transaction</th>
                                            <th>Sub Type</th>
                                            <th>Amount</th>
                                            <th>Original Status</th>
                                            <th>Overall Status</th>
                                            <th>Forecast Ending Balance</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {resultTransEditable.length > 0 ? (
                                              resultTransEditable
                                                //.filter((row) => row.TransactionStatus !== "COMPLETED" && row.TransactionTitle != "	Earned Performance Fee")
                                                .map(row => (
                                                  <tr
                                                    key={row.CounterID}
                                                    style={{
                                                      backgroundColor:
                                                        row.EndingBalance < 0 ?  '#ffeaeaff' : 'inherit',
                                                    }}
                                                  >
                                                    <td>{row.CounterID}</td>
                                                    <td>{row.DebtID || 'N/A'}</td>
                                                    <td>{row.TransID || 'N/A'}</td>
                                                    <td>{row.ProcessDate || 'N/A'}</td>
                                                    <td>{row.ClearedDate || 'N/A'}</td>
                                                    <td>{row.YearMonth || 'N/A'}</td>
                                                    <td>{row.TransactionTitle || 'N/A'}</td>
                                                    <td>{row.SubTypeName || 'N/A'}</td>
                                                    <td>
                                                      <span
                                                        style={{
                                                          color: 
                                                              row.Type?.toUpperCase() === "CREDIT" 
                                                              ? 'red' 
                                                              : row.Type?.toUpperCase() === "DEBIT"
                                                              ? 'green'
                                                              : 'purple',
                                                        }}
                                                      >
                                                      {
                                                        row.Type?.toUpperCase() === "CREDIT"  
                                                        ? '-' 
                                                        : row.Type?.toUpperCase() === "DEBIT"
                                                        ? '+' 
                                                        : ''
                                                      } 
                                                      {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                                      </span>
                                                    </td>
                                                   <td>
                                                      <select
                                                        value={row.OriginalTransactionStatus || "N/A"}
                                                        onChange={(e) => handleStatusChange(row, e.target.value)}
                                                        className="ddl"
                                                      >
                                                        {statusOptions.map((status, i) => (
                                                          <option key={i} value={status}>
                                                            {status}
                                                          </option>
                                                        ))}
                                                      </select>
                                                    </td>
                                                    <td>
                                                      <span
                                                        className="badge"
                                                        style={{
                                                          backgroundColor:
                                                            row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                                              ? '#b7ffd8ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                                              ? '#ffebb7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                                              ? '#ffb7b7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'CANCELLED'
                                                              ? '#ddddddff'
                                                            : 'inherit',
                                                        }}
                                                      >
                                                        {row.TransactionStatus || 'N/A'}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span
                                                        style={{
                                                          color: row.ForecastEndingBalance < 0 
                                                          ? 'red' 
                                                          : 'green',
                                                        }}
                                                        title={
                                                            row.Type?.toUpperCase() === "CREDIT"  
                                                            ? 'Ending Balance - Decreased'
                                                            : row.Type?.toUpperCase() === "DEBIT"
                                                            ? 'Ending Balance - Increased'
                                                            : 'Ending Balance - No Changes'
                                                          }
                                                      >
                                                        {formatCurrencyUSD(
                                                          Number(row.ForecastEndingBalance || '0.00').toFixed(2)
                                                        )}{' '}
                                                        <span
                                                          style={{
                                                            color: 
                                                            row.Type?.toUpperCase() === "CREDIT"  
                                                            ? 'red' 
                                                            : row.Type?.toUpperCase() === "DEBIT"
                                                            ? 'green' 
                                                            : 'purple',
                                                          }}
                                                        >
                                                          {
                                                          row.Type?.toUpperCase() === "CREDIT"
                                                          ? '⬇︎' 
                                                          : row.Type?.toUpperCase() === "DEBIT" 
                                                          ? '⬆︎' 
                                                          : '➖'
                                                          } 
                                                        </span>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="8">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                               </TabPanel>

                               <TabPanel value={valueTransEditable} index={1}>
                                  <label>📌 The Recalculation of EPF per Creditor / Debt ID automatically removes the schedule EPF of selected creditor</label><br/>
                                  <label>📌 The Forecast Remaining Balance may display negative amounts even before fee collection has been deducted.</label><br/>
                                  <label>📌 The system simulates accelerated fee collection and predicts forecast balances to help prevent negative balances in the future</label><br/>
                                  <label>📌 Monthly transaction recalculation view is now available</label><br/><br/><br/>
                                  <button className="btn btn-secondary"  onClick={handleClickFeeRecalculation} >Calculate</button><br/><br/>
                                  <div className="table-container table-sm">
                                    {results.length > 0 && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Month</th>
                                            <th>Available EPF To Collect</th>
                                            <th>EPF Remaining Balance </th>
                                            <th>Forecast Remaining Balance (After EPF Collection)</th>
                                            <th>Schedule</th>
                                            <th>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {results.length > 0 ? (
                                            results.map((row) => {
                                              // Ensure item has the necessary fields before rendering
                                            
                                              return (
                                              <tr key={row.month}>
                                                <td>{row.month}</td>
                                                <td>
                                                    <span 
                                                        style={{
                                                        color:
                                                            row.feeCollected == '0'
                                                            ? 'inherit'
                                                            : 'green',
                                                        }}
                                                    > {formatCurrencyUSD(Number(row.feeCollected).toFixed(2))}
                                                    </span>
                                                </td>
                                                <td>
                                                  <span 
                                                        style={{
                                                        color:
                                                            row.remainingFee == '0'
                                                            ? 'inherit'
                                                            : 'red',
                                                        }}
                                                    > {formatCurrencyUSD(Number(row.remainingFee).toFixed(2))}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span 
                                                        style={{
                                                        color:
                                                            row.remainingBalance < 0
                                                            ? 'red'
                                                            : 'green',
                                                        }}
                                                    >
                                                    {formatCurrencyUSD(Number(row.remainingBalance).toFixed(2))}
                                                    </span>
                                                </td>
                                                <td title="Recommended Date: End of the Month">{row.scheduleDate}</td>
                                                <td>
                                                  <button
                                                    id="btn-view-auto-credit-debit"
                                                    onClick={() => {
                                                        setSelectedRow(row);
                                                        const monthYear = parseScheduleDateToYearMonth(row.scheduleDate);
                                                        const filtered = getDebtDetailsAllTransactionsEditableFilteredByMonth(monthYear);

                                                        const debtID = selectedDebt.debtId;
                                                        const filteredRemovedEPF = filtered.filter(item =>
                                                          !(item.TransactionTitle === "Earned Performance Fee" && item.DebtID === debtID)
                                                        );

                                                        const { totalDebit, totalCredit } = computeDebitCreditTotals(filteredRemovedEPF);

                                                        // Save totals to state so you can display them
                                                        setTotalDebit(totalDebit);
                                                        setTotalCredit(totalCredit);

                                                        setTabResultsByMonthYear(filteredRemovedEPF);
                                                        setIsModalEditableTransactionOpen(true);
                                                        
                                                    }}
                                                    className="btn btn-custom"
                                                    title="View Debit Credit Scheduled Transactions"
                                                  >
                                                    📄
                                                  </button>
                                                </td>
                                              </tr>
                                              );
                                            })
                                          ) : (
                                            <tr>
                                              <td colSpan="4">No data available</td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    )}
                                    </div>
                               </TabPanel>
                            </Box>
                        </Modal>

                        <Modal isOpen={isModalRecalculationFeesOpen} onClose={() => setIsModalRecalculationFeesOpen(false)}>
                            <h2>Multiple EPF Rebalancer</h2>
                            <hr/>
                            <label>🧩 This setup recalculates the EPF for all Debt IDs or Creditors with a remaining EPF balance, based on the selected Collection Fee Type.</label><br/>
                            <br/>
                            <div className="dashboard">
                                <div className="flex-container">
                                    <div className="column">
                                        <label className="container-title">Total Fee Outstanding</label>
                                        {isVisible && (<span className="spinner"></span>)}
                                        <label 
                                        className="container-count" 
                                        style={{
                                            color: totalFees < 0? 'red' : 'green',
                                            }}
                                        >{formatCurrencyUSD(Number(totalFees.toFixed(2)))}</label>
                                    </div>
                                    <div className="column">
                                        <label className="container-title">Current Savings Account Balance</label>
                                        {isVisible && (<span className="spinner"></span>)}
                                        <label 
                                        className="container-count" 
                                        style={{
                                            color: accountBalData < 0? 'red' : 'green',
                                            }}
                                        >{formatCurrencyUSD(Number(accountBalData.toFixed(2)))}</label>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                  <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> EPF Remaining </th>
                                  </tr>
                                </thead>
                                <tbody>
                                 {data.length > 0 ? (
                                    data
                                      .filter(item => item.pendingFee > 0) // ✅ Only items with pendingFee > 0
                                      .map(item => (
                                        <tr key={item.debtId}>
                                          <td>{item.debtId}</td>
                                          <td>{item.accountNumber}</td>
                                          <td>{item.creditorName}</td>
                                          <td>{formatCurrencyUSD(Number(item.pendingFee || 0).toFixed(2))}</td>
                                        </tr>
                                      ))
                                  ) : (
                                    <tr>
                                      <td colSpan="5">No data available</td>
                                    </tr>
                                  )}
                                                           
                                </tbody>
                              </table>
                            </div>

                            <Box sx={{ width: '100%' }}>
                              <Tabs value={valueTransEditable} onChange={handleChangeTransEditable} aria-label="basic tabs">
                                <Tab label="Scheduled Transactions" />
                                <Tab label="Multiple EPF Recalculation" />
                              </Tabs>

                              <TabPanel value={valueTransEditable} index={0}>
                                  <label>📌 This scheduled / pending transaction list are for simulation.</label><br/>
                                  <label>📌 Selected fields, such as the Original Status (dropdown), are editable for simulation. When changed, the related columns and amounts are automatically updated.</label><br/><br/><br/>
                                  <div className="table-container table-sm">
                                    {resultTransEditable.length > 0 && (
                                      <table className="table-bordered scrollable-table">
                                        <thead>
                                          <tr>
                                            <th>Item #</th>
                                            <th>Debt ID</th>
                                            <th>Trans ID</th>
                                            <th>Process Date</th>
                                            <th>Cleared Date</th>
                                            <th>Year Month</th>
                                            <th>Transaction</th>
                                            <th>Sub Type</th>
                                            <th>Amount</th>
                                            <th>Original Status</th>
                                            <th>Overall Status</th>
                                            <th>Forecast Ending Balance</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {resultTransEditable.length > 0 ? (
                                              resultTransEditable
                                                //.filter((row) => row.TransactionStatus !== "COMPLETED" && row.TransactionTitle != "	Earned Performance Fee")
                                                .map(row => (
                                                  <tr
                                                    key={row.CounterID}
                                                    style={{
                                                      backgroundColor:
                                                        row.EndingBalance < 0 ?  '#ffeaeaff' : 'inherit',
                                                    }}
                                                  >
                                                    <td>{row.CounterID}</td>
                                                    <td>{row.DebtID || 'N/A'}</td>
                                                    <td>{row.TransID || 'N/A'}</td>
                                                    <td>{row.ProcessDate || 'N/A'}</td>
                                                    <td>{row.ClearedDate || 'N/A'}</td>
                                                    <td>{row.YearMonth || 'N/A'}</td>
                                                    <td>{row.TransactionTitle || 'N/A'}</td>
                                                    <td>{row.SubTypeName || 'N/A'}</td>
                                                    <td>
                                                      <span
                                                        style={{
                                                          color: 
                                                              row.Type?.toUpperCase() === "CREDIT" 
                                                              ? 'red' 
                                                              : row.Type?.toUpperCase() === "DEBIT"
                                                              ? 'green'
                                                              : 'purple',
                                                        }}
                                                      >
                                                      {
                                                        row.Type?.toUpperCase() === "CREDIT"  
                                                        ? '-' 
                                                        : row.Type?.toUpperCase() === "DEBIT"
                                                        ? '+' 
                                                        : ''
                                                      } 
                                                      {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                                      </span>
                                                    </td>
                                                   <td>
                                                      <select
                                                        value={row.OriginalTransactionStatus || "N/A"}
                                                        onChange={(e) => handleStatusChange(row, e.target.value)}
                                                        className="ddl"
                                                      >
                                                        {statusOptions.map((status, i) => (
                                                          <option key={i} value={status}>
                                                            {status}
                                                          </option>
                                                        ))}
                                                      </select>
                                                    </td>
                                                    <td>
                                                      <span
                                                        className="badge"
                                                        style={{
                                                          backgroundColor:
                                                            row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                                              ? '#b7ffd8ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                                              ? '#ffebb7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                                              ? '#ffb7b7ff'
                                                            : row.TransactionStatus?.toUpperCase() === 'CANCELLED'
                                                              ? '#ddddddff'
                                                            : 'inherit',
                                                        }}
                                                      >
                                                        {row.TransactionStatus || 'N/A'}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      <span
                                                        style={{
                                                          color: row.ForecastEndingBalance < 0 
                                                          ? 'red' 
                                                          : 'green',
                                                        }}
                                                        title={
                                                            row.Type?.toUpperCase() === "CREDIT"  
                                                            ? 'Ending Balance - Decreased'
                                                            : row.Type?.toUpperCase() === "DEBIT"
                                                            ? 'Ending Balance - Increased'
                                                            : 'Ending Balance - No Changes'
                                                          }
                                                      >
                                                        {formatCurrencyUSD(
                                                          Number(row.ForecastEndingBalance || '0.00').toFixed(2)
                                                        )}{' '}
                                                        <span
                                                          style={{
                                                            color: 
                                                            row.Type?.toUpperCase() === "CREDIT"  
                                                            ? 'red' 
                                                            : row.Type?.toUpperCase() === "DEBIT"
                                                            ? 'green' 
                                                            : 'purple',
                                                          }}
                                                        >
                                                          {
                                                          row.Type?.toUpperCase() === "CREDIT"
                                                          ? '⬇︎' 
                                                          : row.Type?.toUpperCase() === "DEBIT" 
                                                          ? '⬆︎' 
                                                          : '➖'
                                                          } 
                                                        </span>
                                                      </span>
                                                    </td>
                                                  </tr>
                                                ))
                                            ) : (
                                              <tr>
                                                <td colSpan="8">No data available</td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    )}
                                  </div>
                              </TabPanel>
                              <TabPanel value={valueTransEditable} index={1}>
                                  <label>📌 The Recalculation of EPF of all Creditor / Debt ID automatically removes all the scheduled EPF</label><br/>
                                  <label>📌 The Forecast Remaining Balance may display negative amounts even before fee collection has been deducted.</label><br/>
                                  <label>📌 The system simulates accelerated fee collection and predicts forecast balances to help prevent negative balances in the future</label><br/>
                                  <br/>
                                  <button className="btn btn-secondary" onClick={handleClickFeesRecalculation}>Calculate</button><br/><br/>
                            
                                  <div className="table-container table-sm">
                                    {results && results.length > 0 ? (
                                      [...results]
                                        .filter(debtResult =>
                                          debtResult?.feeSchedule?.some(entry => entry.feeCollected > 0)
                                        )
                                        .sort((a, b) => {
                                          const feeA = parseFloat(data.find(d => d.debtId === a.debtId)?.pendingFee || 0);
                                          const feeB = parseFloat(data.find(d => d.debtId === b.debtId)?.pendingFee || 0);

                                          if (feeCollectionType === '1') return feeB - feeA;
                                          if (feeCollectionType === '2') return feeA - feeB;
                                          return 0;
                                        })
                                        .map((debtResult) => (
                                          <div key={debtResult.debtId} style={{ marginBottom: '2rem' }}>
                                            <h3 style={{ marginTop: '1rem' }}>Debt ID: {debtResult.debtId} - {debtResult.creditor}</h3>
                                            <table className="table-bordered scrollable-table">
                                              <thead>
                                                <tr>
                                                  <th>Month</th>
                                                  <th>Available EPF To Collect</th>
                                                  <th>EPF Remaining Balance </th>
                                                  <th>Forecast Remaining Balance (After EPF Collection)</th>
                                                  <th>Schedule</th>
                                                  <th>Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {[...debtResult.feeSchedule]
                                                  //.sort((a, b) => new Date(a.scheduleDateObj) - new Date(b.scheduleDateObj)) // Optional: sort rows by schedule date
                                                  .map((row, idx) => (
                                                    <tr key={`${debtResult.debtId}-${row.month}-${idx}`}>
                                                      <td>{row.month}</td>
                                                      <td>
                                                          <span 
                                                              style={{
                                                              color:
                                                                  row.feeCollected == '0'
                                                                  ? 'inherit'
                                                                  : 'green',
                                                              }}
                                                          > {formatCurrencyUSD(Number(row.feeCollected).toFixed(2))}
                                                          </span>
                                                      </td>
                                                      <td>
                                                        <span 
                                                              style={{
                                                              color:
                                                                  row.remainingFee == '0'
                                                                  ? 'inherit'
                                                                  : 'red',
                                                              }}
                                                          > {formatCurrencyUSD(Number(row.remainingFee).toFixed(2))}
                                                          </span>
                                                      </td>
                                                      <td>
                                                          <span 
                                                              style={{
                                                              color:
                                                                  row.remainingBalance < 0
                                                                  ? 'red'
                                                                  : 'green',
                                                              }}
                                                          >
                                                          {formatCurrencyUSD(Number(row.remainingBalance).toFixed(2))}
                                                          </span>
                                                      </td>
                                                      <td title="Recommended Date: End of the Month">{row.scheduleDate}</td>
                                                      <td>
                                                        <button
                                                          id="btn-view-auto-credit-debit"
                                                          onClick={() => {
                                                            setSelectedRow(row);
                                                            const monthYear = parseScheduleDateToYearMonth(row.scheduleDate);
                                                            const filtered = getDebtDetailsAllTransactionsEditableFilteredByMonth(monthYear);

                                                            const filteredRemovedEPF = filtered.filter(item =>
                                                              item.TransactionTitle !== "Earned Performance Fee"
                                                            );
                                                            const { totalDebit, totalCredit } = computeDebitCreditTotals(filteredRemovedEPF);

                                                            // Save totals to state so you can display them
                                                            setTotalDebit(totalDebit);
                                                            setTotalCredit(totalCredit);

                                                            setTabResultsByMonthYear(filteredRemovedEPF);
                                                            setIsModalEditableTransactionOpen(true);
                                                          }}
                                                          className="btn btn-custom"
                                                          title="View Debit Credit Scheduled Transactions"
                                                        >
                                                          📄
                                                        </button>
                                                      </td>
                                                    </tr>
                                                  ))}
                                              </tbody>
                                            </table>
                                          </div>
                                        ))
                                    ) : (
                                      <p>No data available</p>
                                    )}
                                  </div>

                              </TabPanel>
                            </Box>
                            
                        </Modal>
                         <Modal isOpen={isModalEditableTransactionOpen} onClose={() => setIsModalEditableTransactionOpen(false)}>
                            <h2>Scheduled Transaction Details</h2>
                            <hr/>

                              <div className="dashboard">
                                <div className="flex-container">
                                    <div className="column">
                                        <label className="container-title">Total Debit (In)</label>
                                        {isVisible && (<span className="spinner"></span>)}
                                        <label 
                                        className="container-count" 
                                        style={{
                                            color: 'green',
                                            }}
                                        >{formatCurrencyUSD(Number(totalDebit.toFixed(2)))}</label>
                                    </div>
                                    <div className="column">
                                        <label className="container-title">Total Credit (Out)</label>
                                        {isVisible && (<span className="spinner"></span>)}
                                        <label 
                                        className="container-count" 
                                        style={{
                                            color: 'red',
                                            }}
                                        >{formatCurrencyUSD(Number(totalCredit.toFixed(2)))}</label>
                                    </div>
                                    
                                </div>
                              </div>
                              <div className="table-container table-sm">
                                {tabResultsByMonthYear.length > 0 && (
                                  <table className="table-bordered scrollable-table">
                                    <thead>
                                      <tr>
                                        <th>Item #</th>
                                        <th>Debt ID</th>
                                        <th>Trans ID</th>
                                        <th>Process Date</th>
                                        <th>Cleared Date</th>
                                        <th>Year Month</th>
                                        <th>Transaction</th>
                                        <th>Sub Type</th>
                                        <th>Amount</th>
                                        <th>Original Status</th>
                                        <th>Overall Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {tabResultsByMonthYear.length > 0 ? (
                                          tabResultsByMonthYear
                                            .map(row => (
                                              <tr
                                                key={row.CounterID}
                                                style={{
                                                  backgroundColor:
                                                    row.EndingBalance < 0 ?  '#ffeaeaff' : 'inherit',
                                                }}
                                              >
                                                <td>{row.CounterID}</td>
                                                <td>{row.DebtID || 'N/A'}</td>
                                                <td>{row.TransID || 'N/A'}</td>
                                                <td>{row.ProcessDate || 'N/A'}</td>
                                                <td>{row.ClearedDate || 'N/A'}</td>
                                                <td>{row.YearMonth || 'N/A'}</td>
                                                <td>{row.TransactionTitle || 'N/A'}</td>
                                                <td>{row.SubTypeName || 'N/A'}</td>
                                                <td>
                                                  <span
                                                    style={{
                                                      color: 
                                                          row.Type?.toUpperCase() === "CREDIT" 
                                                          ? 'red' 
                                                          : row.Type?.toUpperCase() === "DEBIT"
                                                          ? 'green'
                                                          : 'purple',
                                                    }}
                                                  >
                                                  {
                                                    row.Type?.toUpperCase() === "CREDIT"  
                                                    ? '-' 
                                                    : row.Type?.toUpperCase() === "DEBIT"
                                                    ? '+' 
                                                    : ''
                                                  } 
                                                  {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                                  </span>
                                                </td>
                                                <td>{row.OriginalTransactionStatus || 'N/A'}</td>
                                                <td>
                                                  <span
                                                    className="badge"
                                                    style={{
                                                      backgroundColor:
                                                        row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                                        ? '#b7ffd8ff'
                                                        : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                                        ? '#ffebb7ff'
                                                        : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                                        ? '#ffb7b7ff'
                                                        : 'inherit',
                                                    }}
                                                  >
                                                    {row.TransactionStatus || 'N/A'}
                                                  </span>
                                                </td>
                                               
                                              </tr>
                                            ))
                                        ) : (
                                          <tr>
                                            <td colSpan="10">No data available</td>
                                          </tr>
                                        )}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            
                        </Modal>

                        <Modal isOpen={isModalRecalculationSettlementOpen} onClose={() => setIsModalRecalculationSettlementOpen(false)}>
                            <h2>Settlement Recalculation</h2>

                            <div className="table-container table-xsm">
                               <table className="table-bordered scrollable-table">
                                <thead>
                                   <tr>
                                    <th> Debt ID </th>
                                    <th> Account Number </th>
                                    <th> Creditor </th>
                                    <th> EPF Remaining </th>
                                    <th> Savings Account Balance </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{selectedDebt?.debtId}</td>
                                    <td>{selectedDebt?.accountNumber}</td>
                                    <td>{selectedDebt?.creditorName}</td>
                                    <td>{formatCurrencyUSD(Number(selectedDebt?.pendingFee || 0).toFixed(2))}</td>
                                    <td>
                                        <span 
                                            style={{
                                            color:
                                                accountBalData < 0
                                                ? 'red'
                                                : 'green',
                                            }}
                                        >
                                        {formatCurrencyUSD(Number(accountBalData || '0.00').toFixed(2))}
                                        </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <button className="btn btn-secondary"  onClick={handleClick} >Calculate</button><br/><br/>
                            
                            <div className="table-container table-sm">
                            {results.length > 0 && (
                              <table className="table-bordered scrollable-table">
                                <thead>
                                  <tr>
                                    <th onClick={() => handleSort('Month')}>
                                    Month {sortColumn === 'Month' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('FeeCollected')}>
                                    Fee Collected{' '}
                                      {sortColumn === 'Fee Collected' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('RemainingFee')}>
                                    Remaining Fee {sortColumn === 'RemainingFee' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('RemainingBal')}>
                                    Remaining Balance {sortColumn === 'RemainingBal' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => handleSort('Schedule')}>
                                    Schedule {sortColumn === 'Schedule' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {results.length > 0 ? (
                                    results.map((row) => {
                                      // Ensure item has the necessary fields before rendering
                                    
                                      return (
                                      <tr key={row.month}>
                                        <td>{row.month}</td>
                                        <td>{formatCurrencyUSD(Number(row.feeCollected).toFixed(2))}</td>
                                        <td>{formatCurrencyUSD(Number(row.remainingFee).toFixed(2))}</td>
                                        <td>
                                            <span 
                                                style={{
                                                color:
                                                    row.remainingBalance < 0
                                                    ? 'red'
                                                    : 'green',
                                                }}
                                            >
                                            {formatCurrencyUSD(Number(row.remainingBalance).toFixed(2))}
                                            </span>
                                        </td>
                                        <td>{row.scheduleDate}</td>
                                      </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td colSpan="3">No data available</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                            </div>
                        </Modal>


                        </td>
                      </tr>
                     
                    );
                   
                  })
                ) : (
                  <tr>
                    <td colSpan="13">No data available</td>
                  </tr>
                )}
                 {/* <tr>
                  <td colSpan="12"  style={{fontSize: '1.5em'}}></td>
                </tr>
                <tr>
                  <td colSpan="12"  style={{fontSize: '1.5em'}}></td>
                </tr> */}
              </tbody>
            </table>
            <br/><br/><br/>
          </div>
            

          {/* <button className="btn btn-secondary"  onClick={handleClickTransactionsWODebtID} >View Transaction Details</button><br/><br/> */}
          <Box sx={{ width: '100%' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs">
              <Tab label="All Transactions" />
              {/* <Tab label="Tab Three" /> */}
            </Tabs>
            <TabPanel value={value} index={0}>
                
              <DebtIDFilterDropdown
                selectedFilter={selectedDebtIdFilter}
                onChange={setSelectedDebtIdFilter}
                options={uniqueDebtIds}
              />

              <TableNameFilterDropdown
                selectedFilter={selectedTableNameFilter}
                onChange={setSelectedTableNameFilter}
                options={uniqueTableNames}
              />

              <StatusFilterDropdown
                selectedFilter={selectedStatusFilter}
                onChange={setSelectedStatusFilter}
                options={filteredUniqueStatuses}
              />

              <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px' }}>
                <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                  [Cleared Date] From 
                </label>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  style={{
                    border: '1px solid #D1D5DB',
                    borderRadius: '7px',
                    padding: '10px',
                    fontSize: '1em',
                    backgroundColor: 'white',
                    width: '150px'
                  }}
                />
              </div>

              <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '140px', marginBottom: '10px', marginLeft: '10px' }}>
                <label style={{ fontSize: '1em', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                  [Cleared Date] To 
                </label>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  style={{
                    border: '1px solid #D1D5DB',
                    borderRadius: '7px',
                    padding: '10px',
                    fontSize: '1em',
                    backgroundColor: 'white',
                    width: '150px'
                  }}
                />
              </div>
                
              <div style={{ display: 'inline-flex', flexDirection: 'column', minWidth: '100px', marginBottom: '10px', marginLeft: '10px' }}>
                <button
                  className="btn"
                  style={{ marginLeft: '10px', height: '40px', alignSelf: 'flex-end', position: 'relative', top: '30px', backgroundColor: '#fc8484ff' }}
                  onClick={clearFilters}
                >
                  Clear Filters
                </button>
              </div>

                <div className="table-container table-sm">
                  {sortedData.length > 0 && (
                    <table className="table-bordered scrollable-table">
                      <thead>
                        <tr>
                          <th onClick={() => handleSort('CounterID')} title="Sort by Item #">Item # {sortColumn === 'CounterID' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('DebtID')} title="Sort by Debt ID">Debt ID {sortColumn === 'DebtID' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('TransID')} title="Sort by Trans ID ">Trans ID {sortColumn === 'TransID' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('ProcessDate')} title="Sort by Process Date">Process Date {sortColumn === 'ProcessDate' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('ClearedDate')} title="Sort by Cleared Date">Cleared Date {sortColumn === 'ClearedDate' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('Transaction')} title="Sort by Transaction">Transaction {sortColumn === 'Transaction' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th>Sub Type</th>
                          <th onClick={() => handleSort('Amount')} title="Sort by Amount">Amount {sortColumn === 'Amount' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('OriginalStatus')} title="Sort by Status">Original Status {sortColumn === 'OriginalStatus' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('OverallStatus')} title="Sort by Status">Overall Status {sortColumn === 'OverallStatus' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('EndingBalance')} title="Sort by Current Ending Balance">Current Ending Balance {sortColumn === 'CurrentEndingBalance' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                          <th onClick={() => handleSort('EndingBalance')} title="Sort by Forecast Ending Balance">Forecast Ending Balance {sortColumn === 'ForecastEndingBalance' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.length > 0 ? (
                            sortedData
                              .map(row => (
                                <tr
                                  key={row.CounterID}
                                  style={{
                                    backgroundColor: (
                                      row.ForecastEndingBalance < 0 
                                      ? '#ffeaeaff' 
                                      : row.StatusBySched === "PAST SCHEDULED" || row.StatusBySched === "PAST PENDING" || row.StatusBySched === "SPECIAL"
                                      ? '#f5f2ffff' 
                                      : 'inherit'
                                    ),
                                  }}
                                  title = {(
                                    row.ForecastEndingBalance < 0 
                                      ? 'Transaction with Negative Forecast Ending Balance'
                                      : row.StatusBySched === "PAST SCHEDULED" || row.StatusBySched === "PAST PENDING"
                                      ? 'Past Transaction'
                                      : row.StatusBySched === "SPECIAL"
                                      ? 'Special Case Transaction'
                                      : ''
                                  )}
                                >
                                  <td>{row.CounterID}</td>
                                  <td>{row.DebtID || 'N/A'}</td>
                                  <td>{row.TransID || 'N/A'}</td>
                                  <td>{row.ProcessDate || 'N/A'}</td>
                                  <td>{row.ClearedDate || 'N/A'}</td>
                                  <td>{row.TransactionTitle || 'N/A'}</td>
                                  <td>{row.SubTypeName || 'N/A'}</td>
                                  <td>
                                    <span
                                      style={{
                                        color: 
                                            row.Type?.toUpperCase() === "CREDIT" 
                                            ? 'red' 
                                            : row.Type?.toUpperCase() === "DEBIT"
                                            ? 'green'
                                            : 'purple',
                                      }}
                                    >
                                    {
                                      row.Type?.toUpperCase() === "CREDIT"  
                                      ? ' - ' 
                                      : row.Type?.toUpperCase() === "DEBIT"
                                      ? ' + ' 
                                      : ''
                                    } 
                                    {formatCurrencyUSD(Number(row.Amount || '0.00').toFixed(2))}
                                    </span>
                                  </td>
                                  <td>{row.OriginalTransactionStatus || 'N/A'}</td>
                                  <td>
                                    <span
                                      className="badge"
                                      style={{
                                        backgroundColor:
                                          row.TransactionStatus?.toUpperCase() === 'COMPLETED'
                                          ? '#b7ffd8ff'
                                          : row.TransactionStatus?.toUpperCase() === 'SCHEDULED'
                                          ? '#ffebb7ff'
                                          : row.TransactionStatus?.toUpperCase() === 'PENDING'
                                          ? '#ffb7b7ff'
                                          : row.TransactionStatus?.toUpperCase() === 'CANCELLED'
                                          ? '#ddddddff'
                                          : 'inherit',
                                      }}
                                    >
                                      {row.TransactionStatus || 'N/A'}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      style={{
                                        color: row.CurrentEndingBalance < 0 
                                        ? 'red' 
                                        : 'green',
                                      }}
                                      title={
                                          row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT' )
                                          ? 'Ending Balance - Decreased'
                                          : row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL')
                                          ? 'Ending Balance - No Changes'
                                          : row.Type?.toUpperCase() === "DEBIT" && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT' )
                                          ? 'Ending Balance - Increased'
                                          : row.Type?.toUpperCase() === "DEBIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL')
                                          ? 'Ending Balance - No Changes'
                                          : 'Ending Balance - No Changes'
                                        }
                                    >
                                      {formatCurrencyUSD(
                                        Number(row.CurrentEndingBalance || '0.00').toFixed(2)
                                      )}{' '}
                                      <span
                                         style={{
                                          color: 
                                          row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED' )
                                          ? 'red' 
                                          : row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL' ||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT')
                                          ? 'purple' 
                                          : row.Type?.toUpperCase() === "DEBIT" && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED')
                                          ? 'green' 
                                          : row.Type?.toUpperCase() === "DEBIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL' ||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT')
                                          ? 'purple' 
                                          : 'purple'
                                          } 
                                        }
                                      >
                                       {
                                        row.Type?.toUpperCase() === "CREDIT"  &&
                                        (row.StatusBySched?.toUpperCase() === 'UPDATED')
                                        ? '⬇︎' 
                                        : row.Type?.toUpperCase() === "CREDIT"  && 
                                        (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                        row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                        row.StatusBySched?.toUpperCase() === 'SPECIAL' ||
                                        row.StatusBySched?.toUpperCase() === 'CURRENT' )
                                        ? '➖' 
                                        : row.Type?.toUpperCase() === "DEBIT"   &&
                                        (row.StatusBySched?.toUpperCase() === 'UPDATED' )
                                        ? '⬆︎' 
                                        : row.Type?.toUpperCase() === "DEBIT"  && 
                                        (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                        row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                        row.StatusBySched?.toUpperCase() === 'SPECIAL' ||
                                        row.StatusBySched?.toUpperCase() === 'CURRENT' )
                                        ? '➖' 
                                        : '➖'
                                        } 
                                      </span>
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      style={{
                                        color: row.ForecastEndingBalance < 0 
                                        ? 'red' 
                                        : 'green',
                                      }}
                                       title={
                                          row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                          row.StatusBySched?.toUpperCase() === 'UPCOMING')
                                          ? 'Ending Balance - Decreased'
                                          : row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL' ||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT' )
                                          ? 'Ending Balance - No Changes'
                                          : row.Type?.toUpperCase() === "DEBIT" && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                          row.StatusBySched?.toUpperCase() === 'UPCOMING')
                                          ? 'Ending Balance - Increased'
                                          : row.Type?.toUpperCase() === "DEBIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL' ||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT')
                                          ? 'Ending Balance - No Changes'
                                          : 'Ending Balance - No Changes'
                                        }
                                    >
                                      {formatCurrencyUSD(
                                        Number(row.ForecastEndingBalance || '0.00').toFixed(2)
                                      )}{' '}
                                      <span
                                        style={{
                                          color: 
                                          row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'UPCOMING'||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT')
                                          ? 'red' 
                                          : row.Type?.toUpperCase() === "CREDIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL'  )
                                          ? 'purple' 
                                          : row.Type?.toUpperCase() === "DEBIT" && 
                                          (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                          row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                          row.StatusBySched?.toUpperCase() === 'UPCOMING' ||
                                          row.StatusBySched?.toUpperCase() === 'CURRENT')
                                          ? 'green' 
                                          : row.Type?.toUpperCase() === "DEBIT"  && 
                                          (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                          row.StatusBySched?.toUpperCase() === 'SPECIAL')
                                          ? 'purple' 
                                          : 'purple'
                                          } 
                                        }
                                      >
                                        {
                                        row.Type?.toUpperCase() === "CREDIT"  && 
                                        (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                        row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                        row.StatusBySched?.toUpperCase() === 'UPCOMING' ||
                                        row.StatusBySched?.toUpperCase() === 'CURRENT')
                                        ? '⬇︎' 
                                        : row.Type?.toUpperCase() === "CREDIT" && 
                                        (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                        row.StatusBySched?.toUpperCase() === 'SPECIAL')
                                        ? '➖' 
                                        : row.Type?.toUpperCase() === "DEBIT" && 
                                        (row.StatusBySched?.toUpperCase() === 'UPDATED' ||
                                        row.StatusBySched?.toUpperCase() === 'PAST PENDING' ||
                                        row.StatusBySched?.toUpperCase() === 'UPCOMING'||
                                        row.StatusBySched?.toUpperCase() === 'CURRENT')
                                        ? '⬆︎' 
                                        : row.Type?.toUpperCase() === "DEBIT"  &&
                                        (row.StatusBySched?.toUpperCase() === 'PAST SCHEDULED' ||
                                        row.StatusBySched?.toUpperCase() === 'SPECIAL' )
                                        ? '➖' 
                                        : '➖'
                                        } 
                                      </span>
                                    </span>
                                    {/* <td>{row.PastTrans || 'N/A'}</td> */}
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="8">No data available</td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  )}
                </div>
            </TabPanel>
          </Box>
        </div>
      </div>
      {/* <div style={{ padding: '20px' }}>
        <h1>React Modal Example</h1>
        <button onClick={() => setIsModalOpen(true)}>Open Modal</button>

        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <h2>Modal Title</h2>
          <p>This is the content inside the modal!</p>
        </Modal>
      </div> */}
    </div>
  );
};

export default ClientDebtSummary;
